import moment from 'moment';
// import isString from 'lodash/isString';
import isPlainObject from 'lodash/isPlainObject';
import isUndefined from 'lodash/isUndefined';

import React, {
  useEffect,
  useRef,
} from 'react';
import styled, { css } from 'styled-components';

import AntdSelect from 'antd/lib/select';
import AntdCheckbox from 'antd/lib/checkbox';
import AntdAlert from 'antd/lib/alert';
// import AntdCollapse from 'antd/lib/collapse';
// import Input from 'hive-admin/src/components/Input/Input';
import { CopyOutlined } from '@ant-design/icons';
import Field from 'hive-admin/src/components/Field';
import Input from 'hive-admin/src/components/Input/Input';
import FieldSelect from 'hive-admin/src/components/FieldSelect';
import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

// eslint-disable-next-line max-len
// import FieldConnectionSelect from 'hive-admin/src/components/FieldConnectionSelect';

import { useGoogleFonts } from '@flyyer/use-googlefonts';

import Admin from '../../components/Admin';
import {
  InputCheckbox,
  InputFormField,
} from '../../components/FieldTable';
import { PAYMENT_METHODS } from '../../components/FieldPaymentMethods';

import Types from '../../modules/types';

import { renderCurrency } from '../../components/SystemCountry';

import tests from '../../helpers/tests';
import getStoreUrl from '../../helpers/getStoreUrl';
import clickAnchor from '../../helpers/clickAnchor';
import copyToClipboard from '../../helpers/copyToClipboard';
import {
  fieldI18nLanguage,
  createGetI18nFields,
} from '../../helpers/i18n';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import {
  fieldCheckoutCardsTitle as fieldCheckoutCardsTitleImport,
  fieldCheckoutCards as fieldCheckoutCardsImport,
} from '../../components/FieldCheckoutCards';

// import styleThemeObjectExample from './styleThemeObjectExample.json';

const Alert = styled(AntdAlert)`
  .ant-alert-message {
    ${({ type }) => (
        type === 'success'
      ? css`color: #52c41a !important;`
      : type === 'error'
      ? css`color: #f5222d !important;`
      : type === 'warning'
      ? css`color: #faad14 !important;`
      : null
    )}
  }
`;

export const getI18nFields = createGetI18nFields({
  languagesDataKey: 'languages',
});

function createGetAnnotation(fieldName) {
  return (initialAnnotation, { form }) => {
    if (form) {
      const count = form.getFieldValue(fieldName)?.length || 0;
      if (count > 0) {
        return `/ ${count} ${count === 1 ? 'Item' : 'Items'}`;
      }
    }
    return null;
  };
}

// const styleThemeObjectExampleJSON = JSON.stringify(
//   styleThemeObjectExample,
//   null,
//   '  ',
// );

Object.assign(FieldSelect.inputPropsMap, {
  tokenSeparators: true,
  open: true,
});

const {
  CONSTANTS: {
    ShippingProvider,
    ShippingStorage,
    StoreSubscriptionMode,
  },
} = Types;

const {
  viewerIsAdmin,
  viewerIsNotAdmin,
  viewerIsNotThehiveRsAdmin,
  viewerIsNotThehiveRsAdminNorAbdul,

  // activityIsNotEdit,
} = tests;

const storeIsInternal = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'internal',
  '==',
  true,
]);

const storeTypeNotMerchant = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  Types.CONSTANTS.StoreType.MERCHANT,
]);

const storeTypeNotReseller = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  Types.CONSTANTS.StoreType.RESELLER,
]);

const storeTypeNotMerchantNorReseller = Admin.compileFromLibrary([
  'condition.and',
  [
    storeTypeNotMerchant,
    storeTypeNotReseller,
  ],
]);

const shippingPackmanShopNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.PACKMAN_SHOP}.supported`,
  '!==',
  true,
]);

const shippingPackmanRushNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.PACKMAN_RUSH}.supported`,
  '!==',
  true,
]);

const shippingStoreNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.STORE}.supported`,
  '!==',
  true,
]);

const shippingStoreRushNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.STORE_RUSH}.supported`,
  '!==',
  true,
]);

const shippingSelfPickupNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.SELF_PICKUP}.supported`,
  '!==',
  true,
]);

const shippingPOSNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  `shipping.${ShippingProvider.POS}.supported`,
  '!==',
  true,
]);

const viewerIsNotAdminCompiled = Admin.compileFromLibrary(viewerIsNotAdmin);

// const shippingAbstractNotSupported = Admin.compileFromLibrary([
//   'condition.testFieldValue',
//   `shipping.${ShippingProvider.ABSTRACT}.supported`,
//   '!==',
//   true,
// ]);
const shippingAbstractNotSupported = () => false;

const serviceFeeIsNotSupported = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'serviceFee.supportedSwitch',
  '===',
  'DISABLED',
]);

const subscriptionIsNotCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'subscription',
  '!==',
  'CUSTOM',
]);

const consentScreenIsActive = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'consent.active',
  '!==',
  true,
]);

const trnIsActive = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'trn.active',
  '!==',
  true,
]);

const isNotBannerWithContent = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'contentActive',
  '!==',
  true,
]);

// const packmanRushStorageNotLocal = [
//   'condition.testFieldValue',
//   `shipping.${ShippingProvider.PACKMAN_RUSH}.storage`,
//   '===',
//   ShippingStorage.WAREHOUSE,
// ];

const subscriptionModeIsOffline = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'subscriptionMode',
  '===',
  false,
]);

const accountManagementSubscriptionModeIsOffline = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'accountManagementService.active',
  '===',
  false,
]);
const warehouseSubscriptionModeIsOffline = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'warehouseService.active',
  '===',
  false,
]);

const subscriptionIsDisabledline = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'subscriptionMode',
  '===',
  'OFFLINE',
]);

const subscriptionModeIsNotOffline = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'subscriptionMode',
  '!==',
  'OFFLINE',
]);

const activityNotEdit = props => props && props.activity !== 'edit';
const activityNotCreate = props => props && props.activity !== 'create';

export const fieldCheckoutCardsTitle = fieldCheckoutCardsTitleImport;
export const fieldCheckoutCards = fieldCheckoutCardsImport;

export const fieldLogo = Admin.compileFromLibrary(['FieldUploadRefs', {
  name: 'logo',
  label: 'Logo (Light)',
  // rules: [['validation.isRequired']],
  accept: 'image/jpg,image/jpeg,image/png',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 700 }],
  ],
  col: 1,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}]);

export const fieldLogoDark = Admin.compileFromLibrary(['FieldUploadRefs', {
  name: 'logoDark',
  label: 'Logo (Dark)',
  accept: 'image/jpg,image/jpeg,image/png',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 700 }],
  ],
  col: 1,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}]);

export const fieldAccountManager = Admin.compileFromLibrary(
  ['FieldConnectionSelect', {
    name: 'accountManager',
    label: 'Account Manager',
    url: '/users/admins',
    skip: [viewerIsNotAdmin],
    getChoiceLabel: choice => `${choice.name} (${choice.email})`,
  }]
);

export const fieldFavicon = Admin.compileFromLibrary(['FieldUploadRefs', {
  name: 'favicon',
  label: 'Favicon',
  accept: 'image/png,image/*',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 300 }],
  ],
  col: 1,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}]);

export const fieldStoreId = Admin.compileFromLibrary(['FieldText', {
  name: 'storeId',
  label: 'Store ID',
  disabled: [() => true],
  virtual: [() => true],
  skip: [activityNotEdit],
  rules: [['validation.isRequired']],
  Component: styled(React.forwardRef((props, ref) => (
    <Input
      {...props}
      addonAfter={(
        <CopyOutlined
          onClick={() => copyToClipboard(
            props.value
          )}
        />
      )}
      ref={ref}
    />
  )))`
    input {
      color: initial !important;
    }
  `,
}]);

export const fieldName = Admin.compileFromLibrary(['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
  i18nTranslatable: true,
}]);

export const fieldSlug = Admin.compileFromLibrary(['FieldSlug', {
  name: 'slug',
  rules: [['validation.isRequired']],
  disabled: [viewerIsNotAdmin],
  copyLinkValue: false,
  copyLinkSegments: [
    (props) => {
      if (props.data) {
        return getStoreUrl({
          ...props.data,
          slug: props.form.getFieldValue('slug'),
        });
      }
      return null;
    },
  ],
}]);

export const fieldInternal = Admin.compileFromLibrary(['FieldRadio', {
  name: 'internal',
  // label: null,
  label: 'Market',
  initialValue: false,
  choices: [
    { value: false, label: 'Public' },
    { value: true, label: 'Internal' },
  ],
  block: true,
  rules: [['validation.isRequired']],
  disabled: [activityNotCreate],
  virtual: [activityNotCreate],
  hidden: [viewerIsNotAdmin],
}]);

export const fieldType = Admin.compileFromLibrary(['FieldSelect', {
  name: 'type',
  placeholder: 'Store Type',
  initialValue: Types.STORE_TYPE[0],
  rules: [['validation.isRequired']],
  disabled: [activityNotCreate],
  getFieldsToResetOnChange: (props, _value) => {
    if (props.activity === 'create') {
      const subscription = props.form.getFieldValue('subscription');
      if (subscription !== 'CUSTOM') {
        return ['subscription'];
      }
    }
    return [];
  },
  virtual: [
    storeIsInternal,
    activityNotCreate,
  ],
  hidden: [
    storeIsInternal,
    viewerIsNotAdmin,
  ],
  choices: Types.STORE_TYPE.map(storeType => ({
    label: Types.STORE_TYPE_LABELS_MAP[storeType],
    value: storeType,
  })),
}]);

export const fieldStoreCategories = Admin.compileFromLibrary(['FieldSelect', {
  name: 'storeCategories',
  label: 'Store Industries',
  placeholder: 'Global categories store business relates to',
  mode: 'multiple',
  choices: Types.STORE_CATEGORIES_LIST.map(({ id: value, label }) => ({
    value,
    label,
  })),
  skip: [
    viewerIsNotAdmin,
    storeTypeNotMerchant,
  ],
}]);

export const fieldDomains = Admin.compileFromLibrary(['FieldSelect', {
  name: 'domains',
  label: 'Custom Domains',
  placeholder: 'eg: example.com, www.example.com',
  mode: 'tags',
  tokenSeparators: [' ', ','],
  choices: [],
  open: false,
  hidden: [
    viewerIsNotAdmin,
    storeIsInternal,
  ],
  virtual: [
    viewerIsNotAdmin,
    storeIsInternal,
  ],
  disabled: [
    tests.viewerIsAdminAndDoesNotHavePermission('storesCustomDomainsUpdate'),
  ],
  skip: [
    viewerIsNotAdmin,
    storeIsInternal,
  ],
}]);

export const fieldShowItemsLeftInStockThreshold = Admin.compileFromLibrary(
  ['FieldText', {
    name: 'showItemsLeftInStockThreshold',
    label: 'Show items left in stock threshold (-1 to hide)',
    type: 'number',
    col: 12,
  }],
);

export const fieldShowPricesWithVat = Admin.compileFromLibrary(['FieldRadio', {
  name: 'showPricesWithVat',
  label: 'Show prices with VAT',
  block: true,
  initialValue: true,
  choices: [
    { label: 'Enabled', value: true },
    { label: 'Disabled', value: false },
  ],
  col: 12,
}]);

export const fieldSingleItemPerOrder = Admin.compileFromLibrary(['FieldSwitch', {
  name: 'singleItemPerOrder',
  label: 'Allow only one item (quantity = 1) per order',
  initialValue: false,
  help: 'When enabled, the cart can only contain one product and quantity cannot exceed 1.',
  col: 12,
}]);

export const fieldPaymentCheckoutInternationalSupport = (
  Admin.compileFromLibrary(
    ['FieldRadio', {
      name: 'paymentCheckoutInternationalSupport',
      label: 'Accept international payments (checkout.com)',
      initialValue: true,
      choices: [
        { value: true, label: 'Enabled' },
        { value: false, label: 'Disabled' },
      ],
      block: true,
      hidden: [
        viewerIsNotAdmin,
        [
          'condition.fieldIsNotTrue',
          'show_fields_shop_payment',
        ],
      ],
      virtual: [viewerIsNotAdmin],
    }],
  )
);

export const fieldPaymentPaymobInternationalSupport = (
  Admin.compileFromLibrary(
    ['FieldRadio', {
      name: 'paymentPaymobInternationalSupport',
      label: 'Accept international payments (paymob.com)',
      initialValue: true,
      choices: [
        { value: true, label: 'Enabled' },
        { value: false, label: 'Disabled' },
      ],
      block: true,
      hidden: [
        viewerIsNotAdmin,
        [
          'condition.fieldIsNotTrue',
          'show_fields_shop_payment',
        ],
      ],
      virtual: [viewerIsNotAdmin],
    }],
  )
);

// TODO NOT USING TAMARA ANYMORE
// export const fieldPaymentTamaraSupported = Admin.compileFromLibrary(
//   ['FieldRadio', {
//     name: 'paymentTamaraSupported',
//     label: 'Accept payments with financing (tamara.co)',
//     initialValue: false,
//     choices: [
//       { value: true, label: 'Enabled' },
//       { value: false, label: 'Disabled' },
//     ],
//     block: true,
//     hidden: [viewerIsNotAdmin],
//     virtual: [viewerIsNotAdmin],
//   }],
// );

export const fieldPaymentCardProvider = Admin.compileFromLibrary(
  ['FieldSelect', {
    name: 'paymentCardProvider',
    label: 'Payment Card Provider',
    initialValue: null,
    hidden: [
      viewerIsNotAdmin,
      [
        'condition.fieldIsNotTrue',
        'show_fields_shop_payment',
      ],
    ],
    choices: (
      Types.PAYMENT_CARD_PROVIDER_STORE_SUPPORTED_ITEMS
      .map(({ id, label, choiceLabel }) => ({
        value: id,
        label: choiceLabel || label,
      }))
    ),
    renderChoices: (field, props) => {
      const {
        supportedPaymentCardProviders,
        paymentCardProvider,
      } = Types.getSystemCountry(props.data.systemCountry);
      return (
        [
          {
            value: null,
            label: `Default / ${
              Types.PAYMENT_CARD_PROVIDER_STORE_SUPPORTED_MAP[
                paymentCardProvider
              ]?.label || 'N/A'
            }`,
          },
          ...props.choices
          .filter(({ value }) => (
            supportedPaymentCardProviders.includes(value)
          )),
        ].map(choice => props.renderChoice(choice, field, props))
      );
    },
    width: '100%',
    getChoiceLabel: (choice, field, props) => {
      const systemCountry = Types.getSystemCountry(props.data.systemCountry);
      const provider = choice.value || systemCountry.paymentCardProvider;
      const providerObject = Types.PAYMENT_CARD_PROVIDER_STORE_SUPPORTED_MAP[
        provider
      ];
      const fees = props.viewer.settings?.paymentGateway?.[provider];
      return (
        <div>
          <span style={{ fontWeight: 600 }}>{choice.label}</span>
          <span>
            {` (${providerObject?.integrationType || 'N/A'})`}
          </span>
          {
            fees
            ? (
              <span>
                {
                  providerObject.gatewayFeesBasedOnCardDetails
                  ? (
                      `: Local ${
                        systemCountry.currency
                      } ${
                        fees?.national?.chargeAmountFixed || 0
                      } + ${
                        fees?.national?.chargeAmountPercentage || 0
                      }% / International ${
                        systemCountry.currency
                      } ${
                        fees?.international?.chargeAmountFixed
                      } + ${
                        fees?.international?.chargeAmountPercentage
                      }%`
                    )
                  : (
                      `: General ${
                        systemCountry.currency
                      } ${
                        fees.chargeAmountFixed || 0
                      } + ${
                        fees.chargeAmountPercentage || 0
                      }%`
                    )
                }
              </span>
            )
            : null
          }
        </div>
      )
    },
    // block: true,
    disabled: [viewerIsNotThehiveRsAdminNorAbdul],
    skip: [viewerIsNotAdmin],
    // virtual: [viewerIsNotAdmin],
  }],
);

export const fieldAppleDeveloperMerchantIdDomainAssociationFile = (
  Admin.compileFromLibrary(['FieldUploadRefsHorizontal', {
    name: 'appleDeveloperMerchantIdDomainAssociationFile',
    label: 'Apple Domain Verification',
    maxCount: 1,
    accept: 'text/plain',
    transformations: [],
    listType: 'picture',
    uploadLabel: 'Upload',
    hidden: [
      viewerIsNotAdmin,
      [
        'condition.fieldIsNotTrue',
        'show_fields_shop_payment',
      ],
    ],
  }])
);

export const fieldAppleDeveloperMerchantIdDomainAssociationVerified = (
  Admin.compileFromLibrary(['FieldRadio', {
    name: 'appleDeveloperMerchantIdDomainAssociationVerified',
    label: 'Apple Domain Verified',
    initialValue: false,
    choices: [
      { value: true, label: 'Verified' },
      { value: false, label: 'Not Verified' },
    ],
    block: true,
    hidden: [
      viewerIsNotAdmin,
      [
        'condition.fieldIsNotTrue',
        'show_fields_shop_payment',
      ],
    ],
  }])
);

export const fieldPaymentTabbySupported = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'paymentTabbySupported',
    label: 'Accept payments with financing (tabby.ai)',
    initialValue: false,
    choices: [
      { value: true, label: 'Enabled' },
      { value: false, label: 'Disabled' },
    ],
    block: true,
    hidden: [
      viewerIsNotAdmin,
      [
        'condition.fieldIsNotTrue',
        'show_fields_shop_payment',
      ],
    ],
    virtual: [viewerIsNotAdmin],
    disabled: [viewerIsNotAdmin],
  }],
);

const viewerCannotEditServiceFee = tests.viewerIsNotAdminWithEmail([
  ...tests.viewerIsNotAdminWithEmail.THEHIVERS_EMAILS,
  'ajit@packman.app',
  'saleh@packman.app',
]);

export const fieldServiceFee = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'serviceFee.supportedSwitch',
    label: 'Service Fee',
    initialValue: 'DISABLED',
    choices: [
      ...Types.CHARGED_TO_ITEMS.map(({ id, label }) => ({
        value: id,
        label: `Charge To ${label}`,
      })),
      {
        value: 'DISABLED',
        label: 'Disabled',
      },
    ],
    block: true,
    hidden: [
      viewerIsNotAdmin,
      viewerCannotEditServiceFee,
    ],
    virtual: [
      viewerIsNotAdmin,
      viewerCannotEditServiceFee,
    ],
  }],
);

export const fieldServiceFeeFixed = Admin.compileFromLibrary(
  getFilterWithCol(['FieldText', {
    name: 'serviceFee.fixed',
    label: null,
    prefix: 'Fixed Charge:',
    initialValue: 0,
    type: 'number',
    align: 'right',
    addonAfter: renderCurrency(),
    hidden: [
      viewerIsNotAdmin,
      serviceFeeIsNotSupported,
      viewerCannotEditServiceFee,
    ],
    virtual: [
      viewerIsNotAdmin,
      serviceFeeIsNotSupported,
      viewerCannotEditServiceFee,
    ],
  }], 12),
);

export const fieldServiceFeePercentage = Admin.compileFromLibrary(
  getFilterWithCol(['FieldText', {
    name: 'serviceFee.percentage',
    label: null,
    prefix: 'Percentage Charge:',
    initialValue: 0,
    type: 'number',
    align: 'right',
    addonAfter: '%',
    hidden: [
      viewerIsNotAdmin,
      serviceFeeIsNotSupported,
      viewerCannotEditServiceFee,
    ],
    virtual: [
      viewerIsNotAdmin,
      serviceFeeIsNotSupported,
      viewerCannotEditServiceFee,
    ],
  }], 12),
);

export const fieldSubscriptionMode = ['FieldRadio', {
  name: 'subscriptionMode',
  label: 'Set Subscription Mode',
  initialValue: Types.STORE_SUBSCRIPTION_MODE[0],
  choices: Types.STORE_SUBSCRIPTION_MODE_LIST.map(({ id, label }) => ({
    value: id,
    label,
  })),
  hidden: [viewerIsNotAdmin],
  virtual: [viewerIsNotAdmin],
  block: true,
}];

export const fieldSubscription = ['FieldSelect', {
  name: 'subscription',
  placeholder: 'Store Subscription Plan',
  // allowClear: true,
  hidden: [viewerIsNotAdmin],
  virtual: [viewerIsNotAdmin],
  renderChoices: (field, props) => {
    const systemCountryId = (
        props.data?.systemCountry
      ? props.data.systemCountry
      : props.searchParams.sc
    );
    const systemCountry = Types.SYSTEM_COUNTRY_MAP[systemCountryId];
    if (!systemCountry) {
      return [];
    }
    const isReseller = props.form.getFieldValue('type') === 'RESELLER';
    const { SUBSCRIPTION_LIST: subscriptionsList = [] } = systemCountry[(
        isReseller
      ? 'subscriptionsReseller'
      : 'subscriptions'
    )] || {};
    const {
      legacy,
      active,
    } = subscriptionsList.reduce(
      (agr, item) => {
        const option = {
          label: (
              item.legacy
            ? `Legacy: ${item.label}`
            : item.label
          ),
          value: item.id,
        }
        if (item.legacy) {
          agr.legacy.push(option);
        } else {
          agr.active.push(option);
        }
        return agr;
      },
      {
        legacy: [],
        active: [],
      },
    );

    return [
      ...active,
      { label: 'Custom', value: 'CUSTOM' },
      ...legacy,
    ].map(choice => props.renderChoice(choice, field, props));
  },
}];

export const fieldSubscriptionCustomPercentage = Admin.compileFromLibrary(
  ['FieldText', {
    label: null,
    name: 'subscriptionCustom.percentage',
    initialValue: 0,
    prefix: 'Custom Sales Percentage:',
    type: 'number',
    align: 'right',
    addonAfter: '%',
    hidden: [viewerIsNotAdmin, subscriptionIsNotCustom],
    virtual: [viewerIsNotAdmin, subscriptionIsNotCustom],
  }],
);

export const fieldSubscriptionCustomDuration = Admin.compileFromLibrary(
  ['FieldSelect', {
    label: null,
    name: 'subscriptionCustom.duration',
    initialValue: Types.STORE_SUBSCRIPTION_DURATION[0],
    prefix: 'Custom Period:',
    hidden: [viewerIsNotAdmin, subscriptionIsNotCustom],
    virtual: [viewerIsNotAdmin, subscriptionIsNotCustom],
    choices: Types.STORE_SUBSCRIPTION_DURATION_LIST.map(({ id, label }) => ({
      value: id,
      label,
    })),
  }],
);

export const fieldSubscriptionCustomPrice = Admin.compileFromLibrary(
  ['FieldText', {
    label: null,
    name: 'subscriptionCustom.price',
    initialValue: 0,
    prefix: 'Custom Period Price:',
    type: 'number',
    align: 'right',
    addonAfter: renderCurrency(),
    hidden: [viewerIsNotAdmin, subscriptionIsNotCustom],
    virtual: [viewerIsNotAdmin, subscriptionIsNotCustom],
  }],
);

export const fieldSubscriptionStartsAt = ['FieldDatePicker', {
  name: 'subscriptionStartsAt',
  label: 'Subscription Starts Date',
  format: 'll',
  placeholder: 'Date the subscription starts',
  hidden: [viewerIsNotAdmin],
  virtual: [viewerIsNotAdmin],
  skip: [subscriptionModeIsNotOffline],
  prepareValueForInput: value => moment(value),
}];

// eslint-disable-next-line max-len
export const fieldKeyAccountActive = Admin.compileFromLibrary(['FieldRadio', {
  name: 'keyAccount',
  label: 'Key Account',
  block: true,
  initialValue: false,
  choices: [
    { label: 'No', value: false },
    { label: 'Yes', value: true },
  ],
  col: 24,
}]);
// eslint-disable-next-line max-len
export const fieldAccountManagerActive = Admin.compileFromLibrary(['FieldRadio', {
  name: 'accountManagementService.active',
  label: 'Account management',
  block: true,
  initialValue: false,
  choices: [
    { label: 'Disabled', value: false },
    { label: 'Active', value: true },
  ],
  col: 12,
}]);

export const fieldAccountManagerSubscriptionStartsAt = ['FieldDatePicker', {
  name: 'accountManagementService.startDate',
  label: 'Subscription Starts Date',
  format: 'll',
  placeholder: 'Date the subscription starts',
  hidden: [viewerIsNotAdmin, accountManagementSubscriptionModeIsOffline],
  virtual: [viewerIsNotAdmin],
  skip: [],
  prepareValueForInput: value => moment(value),
}];
export const fieldAccountManagerSubscriptionEndsAt = ['FieldDatePicker', {
  name: 'accountManagementService.endDate',
  label: 'Subscription Ends Date',
  format: 'll',
  placeholder: 'Date the subscription ends',
  hidden: [viewerIsNotAdmin, accountManagementSubscriptionModeIsOffline],
  virtual: [viewerIsNotAdmin],
  skip: [],
  prepareValueForInput: value => moment(value),
}];
// eslint-disable-next-line max-len
export const fieldWarehouseServiceActive = Admin.compileFromLibrary(['FieldRadio', {
  name: 'warehouseService.active',
  label: 'Warehouse Service',
  block: true,
  initialValue: false,
  choices: [
    { label: 'Disabled', value: false },
    { label: 'Active', value: true },
  ],
  col: 12,
}]);

export const fieldWarehouseServiceSubscriptionStartsAt = ['FieldDatePicker', {
  name: 'warehouseService.startDate',
  label: 'Subscription Starts Date',
  format: 'll',
  placeholder: 'Date the subscription starts',
  hidden: [viewerIsNotAdmin, warehouseSubscriptionModeIsOffline],
  virtual: [viewerIsNotAdmin],
  skip: [],
  prepareValueForInput: value => moment(value),
}];
export const fieldWarehouseServiceSubscriptionEndsAt = ['FieldDatePicker', {
  name: 'warehouseService.endDate',
  label: 'Subscription Ends Date',
  format: 'll',
  placeholder: 'Date the subscription ends',
  hidden: [viewerIsNotAdmin, warehouseSubscriptionModeIsOffline],
  virtual: [viewerIsNotAdmin],
  skip: [],
  prepareValueForInput: value => moment(value),
}];

export const fieldBrandColor = ['FieldColorPicker', {
  name: 'brandColor',
  label: 'Brand Color',
  rules: [[(config = {}) => ({
    validator: (rule, value, cb) => (cb(
      (!value || !value.length)
      ? undefined
      : /^(hsla?\(|#)/.test(value)
      ? undefined
      : rule.message
    )),
    // eslint-disable-next-line max-len
    message: 'Color must be either hsl (eg. hsl(327, 46%, 46%)) or a HEX String (eg. #AA407A)',
    ...config,
  })]],
  disableAlpha: true,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}];

export const fieldAccentColorPrimary = ['FieldColorPicker', {
  name: 'accentColorPrimary',
  label: 'Accent Color (Primary)',
  rules: [[(config = {}) => ({
    validator: (rule, value, cb) => (cb(
      (!value || !value.length)
      ? undefined
      : /^(hsla?\(|#)/.test(value)
      ? undefined
      : rule.message
    )),
    // eslint-disable-next-line max-len
    message: 'Color must be either hsl (eg. hsl(327, 46%, 46%)) or a HEX String (eg. #AA407A)',
    ...config,
  })]],
  disableAlpha: true,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}];

export const fieldAccentColorSecondary = ['FieldColorPicker', {
  name: 'accentColorSecondary',
  label: 'Accent Color (Secondary)',
  rules: [[(config = {}) => ({
    validator: (rule, value, cb) => (cb(
      (!value || !value.length)
      ? undefined
      : /^(hsla?\(|#)/.test(value)
      ? undefined
      : rule.message
    )),
    // eslint-disable-next-line max-len
    message: 'Color must be either hsl (eg. hsl(327, 46%, 46%)) or a HEX String (eg. #AA407A)',
    ...config,
  })]],
  disableAlpha: true,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_brand',
  ]],
}];

export const fieldAnnouncement = Admin.compileFromLibrary(['FieldText', {
  name: 'announcement',
  label: 'Announcement',
  rules: [[(config = {}) => ({
    type: 'string',
    max: 40,
    message: 'Announcement can only be up to 40 characters long!',
    ...config,
  })]],
  i18nTranslatable: true,
}]);

export const fieldLanguageRaw = ['FieldHidden', {
  name: 'language',
  initialValue: 'en',
}];

export const fieldLanguage = Admin.compileFromLibrary(fieldLanguageRaw);

export const fieldLanguagesRaw = ['FieldTable', {
  name: 'languages',
  label: 'Languages',
  table: { showHeader: true, rowKey: '_id', size: 'small' },
  prepareValueForInput: (value = [], props) => props.viewer.languages.map(
    (language) => ({
      _id: language._id,
      supported: value && value.includes(language._id),
      label: language.name,
    }),
  ),
  // eslint-disable-next-line no-unused-vars
  prepareValueForForm: (value, props) => value.reduce(
    (agr, row) => {
      if (row.supported) {
        agr.push(row._id);
      }
      return agr;
    },
    [],
  ),
  columns: [
    {
      key: 'supported',
      align: 'center',
      width: '50px',
      fields: [{
        name: 'supported',
        ComponentInput: InputCheckbox,
        props: {
          size: 'small',
        },
        getProps: (field, value, props) => ({
          disabled: value?._id === 'en',
          onChange: (event) => {
            const language = props.form.getFieldValue('language');
            if (!event.target.checked && language === value._id) {
              props.form.setFieldsValue({ language: 'en' });
            }
            props.onChange(event);
          },
        }),
      }],
    },
    {
      title: 'Language',
      key: 'label',
      getLabel: ({ label }) => label,
    },
    {
      title: 'Default',
      key: 'default',
      getLabel: (value, props) => {
        const checked = props.form.getFieldValue('language') === value._id;
        return (
          <AntdCheckbox
            // eslint-disable-next-line no-unused-vars
            onChange={(event) => {
              props.form.setFieldsValue({
                language: checked ? 'en' : value._id,
              });
            }}
            checked={checked}
            disabled={!value.supported}
          />
        );
      },
    },
  ],
  rules: [['validation.isRequired']],
}];

export const fieldLanguages = Admin.compileFromLibrary(fieldLanguagesRaw);

export const isNavigationHidden = [
  'condition.fieldIsNotTrue',
  'show_fields_style_navigation',
];

export const fieldNavigationStyle = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationStyle',
    label: 'Style',
    initialValue: 'full',
    choices: [{
      label: 'Full',
      value: 'full',
    }, {
      label: 'Boxed',
      value: 'boxed',
    }],
    block: true,
    col: 24,
    hidden: [isNavigationHidden],
  }],
);

export const fieldNavigationAlignment = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationAlignment',
    label: 'Alignment',
    initialValue: 'regular',
    choices: [{
      label: 'Regular',
      value: 'regular',
    }, {
      label: 'Centered',
      value: 'centered',
    }],
    disabled: [() => true],
    block: true,
    col: 12,
  }],
);

export const fieldNavigationPosition = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationPosition',
    label: 'Position',
    initialValue: 'static',
    choices: [{
      label: 'Static',
      value: 'static',
    }, {
      label: 'Fixed',
      value: 'fixed',
    }, {
      label: 'Dynamic',
      value: 'dynamic',
    }],
    block: true,
    hidden: [isNavigationHidden],
  }],
);

export const fieldNavigationActiveItemStyle = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationActiveItemStyle',
    label: 'Active Item Style',
    choices: [{
      label: 'Dot',
      value: 'dot',
    }, {
      label: 'Underline',
      value: 'underline',
    }, {
      label: 'Box',
      value: 'box',
    }],
    initialValue: 'underline',
    block: true,
    hidden: [isNavigationHidden],
  }],
);
export const fieldNavigationActiveItemPosition = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationActiveItemPosition',
    label: 'Active Item Position',
    choices: [{
      label: 'Top',
      value: 'top',
    }, {
      label: 'Bottom',
      value: 'bottom',
    }],
    initialValue: 'top',
    block: true,
    hidden: [isNavigationHidden],
    skip: [[
      'condition.testFieldValue',
      'navigationActiveItemStyle',
      '!==',
      'dot',
    ]],
  }],
);

export const fieldNavigationMobileNavigationShow = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationMobileNavigationShow',
    label: 'Mobile Navigation Show',
    choices: [{
      label: 'Auto',
      value: 'auto',
    }, {
      label: 'Always',
      value: 'always',
    }],
    initialValue: 'auto',
    block: true,
    col: 12,
    hidden: [isNavigationHidden],
  }],
);

export const fieldNavigationMobileNavigationStyle = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'navigationMobileNavigationStyle',
    label: 'Mobile Navigation Style',
    choices: [{
      label: 'Side',
      value: 'side',
    }, {
      label: 'Full',
      value: 'full',
    }],
    // disabled: [() => true],
    initialValue: 'full',
    block: true,
    col: 12,
    hidden: [isNavigationHidden],
  }],
);

export const fieldNavigationCurrenciesShow = Admin.compileFromLibrary(
  getFilterWithCol(['FieldRadio', {
    name: 'navigationCurrenciesShow',
    label: 'Currency Switcher',
    initialValue: true,
    choices: [{
      label: 'Enabled',
      value: true,
    }, {
      label: 'Disabled',
      value: false,
    }],
    block: true,
  }], 12),
);

export const fieldNavigationSocialHide = Admin.compileFromLibrary(
  getFilterWithCol(['FieldRadio', {
    name: 'navigationSocialHide',
    label: 'Social Icons',
    initialValue: false,
    choices: [{
      label: 'Enabled',
      value: false,
    }, {
      label: 'Disabled',
      value: true,
    }],
    block: true,
  }], 12),
);

const fieldNavigationItemsFields = [
  ['FieldText', {
    name: 'label',
    label: null,
    prefix: 'Label:',
    i18nTranslatable: true,
  }],
  ['FieldText', {
    name: 'link',
    label: null,
    prefix: 'Link:',
    placeholder: 'Use single slash ("/") for Home Page',
  }],
].map(field => getFilterWithCol(field, 12));

export const fieldNavigationItems = Admin.compileFromLibrary(
  ['FieldSortableList', {
    name: 'navigationItems',
    label: 'Items',
    condensed: true,
    shouldRenderPlaceholder: true,
    getItemFields: getI18nFields,
    fields: [
      ...fieldNavigationItemsFields,
      ['FieldSortableList', {
        name: 'items',
        condensed: true,
        head: 'horizontal',
        headSmall: 'vertical',
        label: null,
        addButtonLabel: 'Add Subitem',
        fields: [...fieldNavigationItemsFields],
        getItemFields: getI18nFields,
      }],
    ],
  }],
);

export const fieldNavigationActions = Admin.compileFromLibrary(
  ['FieldSortableList', {
    name: 'navigationActions',
    label: 'Actions',
    condensed: true,
    shouldRenderPlaceholder: true,
    placeholderContent: 'Add actions using the buttons below...',
    getItemFields: getI18nFields,
    fields: [
      ...fieldNavigationItemsFields,
      ['FieldSortableList', {
        name: 'items',
        condensed: true,
        head: 'horizontal',
        headSmall: 'vertical',
        label: null,
        addButtonLabel: 'Add Subitem',
        fields: [...fieldNavigationItemsFields],
        getItemFields: getI18nFields,
      }],
    ],
  }],
);

export const fieldsShopHide = [
  ['announcements', 'Announcements'],
  ['header', 'Header'],
  ['banners', 'Slider'],
  ['sidebar', 'Sidebar'],
  ['footer', 'Footer'],
].map(([name, label]) => ['FieldRadio', {
  name: `shopLayout.${name}.hidden`,
  label: null,
  initialValue: false,
  choices: [
    { value: false, label: `Show ${label}` },
    { value: true, label: `Hide ${label}` },
  ],
  block: true,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_shop_sections',
  ]],
}]);

export const fieldShopCartAlignment = ['FieldRadio', {
  name: 'shopCartAlignment',
  label: 'Cart Alignment',
  initialValue: 'side',
  choices: [
    { value: 'center', label: 'Center' },
    { value: 'side', label: 'Side' },
  ],
  block: true,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_style_shop',
  ]],
}];

export const fieldShopGrid = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'shopGrid',
    label: 'Grid',
    initialValue: 'regular',
    choices: [
      { value: 'regular', label: 'Regular' },
      { value: 'large', label: 'Large' },
    ],
    block: true,
    isDisabled: () => true,
    hidden: [[
      'condition.fieldIsNotTrue',
      'show_fields_style_shop',
    ]],
  }],
);

export const fieldShopBannersAutoplay = ['FieldRadio', {
  name: 'shopBannersAutoplay',
  label: null,
  initialValue: false,
  choices: [
    { value: false, label: 'Autoplay Off' },
    { value: true, label: 'Autoplay On' },
  ],
  block: true,
}];

export const fieldShopBannersOverflow = ['FieldRadio', {
  name: 'shopBannersOverflow',
  label: null,
  initialValue: false,
  choices: [
    { value: false, label: 'Overflow Off' },
    { value: true, label: 'Overflow On' },
  ],
  block: true,
}];

export const fieldShopBanners = Admin.compileFromLibrary(
  ['FieldSortableList', {
    name: 'shopBanners',
    label: null,
    hidden: [
      ['condition.fieldIsNotTrue', 'show_fields_shop_banners'],
    ],
    addButtonLabel: 'Add Banner',
    supportDuplicate: true,
    collapseFieldName: '__collapsed',
    collapseLabelFieldName: 'contentTitle',
    collapseLabelDefault: 'Banner',
    fields: [
      getFilterWithCol(['FieldUploadRefsHorizontal', {
        name: 'image',
        label: null,
        maxCount: 1,
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        transformations: [
          ['GM', { command: 'compress', maxWidth: 2400 }],
          ['GM', { command: 'webp' }],
        ],
        listType: 'picture',
        uploadLabel: 'Upload Image',
      }], 12),
      getFilterWithCol(['FieldUploadRefsHorizontal', {
        name: 'imageMobile',
        label: null,
        maxCount: 1,
        accept: 'image/jpg,image/jpeg,image/png,image/webp',
        transformations: [
          ['GM', { command: 'compress', maxWidth: 1600 }],
          ['GM', { command: 'webp' }],
        ],
        listType: 'picture',
        uploadLabel: 'Upload Mobile Image',
      }], 12),
      // ['FieldText', {
      //   name: 'video',
      //   label: null,
      //   prefix: 'Video URL:',
      //   col: 24,
      // }],
      getFilterWithCol(['FieldRadio', {
        name: 'contentActive',
        label: null,
        // inlineLabelBefore: 'Use Content?',
        initialValue: false,
        choices: [{
          label: 'Media Only',
          value: false,
        }, {
          label: 'Use Content',
          value: true,
        }],
        block: true,
      }], 24),
      getFilterWithCol(['FieldText', {
        name: 'contentTitle',
        label: null,
        prefix: 'Title:',
        skip: [isNotBannerWithContent],
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'contentSubtitle',
        label: null,
        prefix: 'Subtitle:',
        skip: [isNotBannerWithContent],
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'contentButtonLink',
        label: null,
        prefix: 'Link:',
        skip: [isNotBannerWithContent],
      }], 12),
      getFilterWithCol(['FieldText', {
        name: 'contentButtonLabel',
        label: null,
        prefix: 'Button:',
        skip: [isNotBannerWithContent],
      }], 12),
      // ['FieldRadio', {
      //   name: 'contentOverlay',
      //   label: null,
      //   initialValue: false,
      //   col: 24,
      //   choices: [
      //     { value: false, label: 'Overlay Off' },
      //     { value: true, label: 'Overlay On' },
      //   ],
      //   block: true,
      // }],
    ],
  }],
);

export const fieldCategories = ['FieldSortableList', {
  name: 'categories',
  label: 'Categories Order',
  collapseLabelFieldName: 'name',
  head: 'horizontal',
  condensed: true,
  supportRemove: false,
  hidden: [
    ['condition.fieldIsNotTrue', 'show_fields_shop_sidebar'],
  ],
  shouldRenderAddButton: () => false,
  fields: [
    ['FieldReact', {
      name: 'name',
      label: null,
      renderContent: props => (
        <span style={{ fontSize: '18px' }}>
          {props.value}
        </span>
      ),
    }],
  ],
}];

export const fieldCollections = ['FieldSortableList', {
  name: 'collections',
  label: 'Collections Order',
  collapseLabelFieldName: 'name',
  head: 'horizontal',
  condensed: true,
  supportRemove: false,
  hidden: [
    ['condition.fieldIsNotTrue', 'show_fields_shop_sidebar'],
  ],
  shouldRenderAddButton: () => false,
  fields: [
    ['FieldReact', {
      name: 'name',
      label: null,
      renderContent: props => (
        <span style={{ fontSize: '18px' }}>
          {props.value}
        </span>
      ),
    }],
  ],
}];

export const fieldImageSizing = ['FieldRadio', {
  name: 'imageSizing',
  label: 'Product Image Sizing',
  initialValue: Types.IMAGE_SIZING[0],
  choices: (
    Types.IMAGE_SIZING
    .map(value => ({
      label: Types.IMAGE_SIZING_LABELS_MAP[value],
      value,
    }))
  ),
  block: true,
}];

export const fieldStyleImageAspectRatio = ['FieldRadio', {
  name: 'styleImageAspectRatio',
  label: 'Product Image Aspect Ratio',
  initialValue: 'square',
  choices: [
    { value: 'square', label: 'Square' },
    { value: 'portrait', label: 'Portrait' },
    { value: 'landscape', label: 'Landscape' },
  ],
  block: true,
}];

export const fieldStyleImageParallax = ['FieldRadio', {
  name: 'styleImageParallax',
  label: 'Parallax Effect',
  initialValue: 'none',
  choices: [
    { value: 'none', label: 'None' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
  ],
  block: true,
}];

export const [
  fieldGalleryThumbnails,
  fieldGalleryDotNavigation,
  fieldGalleryArrowsNavigation,
  // fieldGalleryFullscreen,
] = [
  ['galleryThumbnails', 'Thumbnails'],
  ['galleryDotNavigation', 'Dot Navigation'],
  ['galleryArrowsNavigation', 'Arrows Navigation'],
  // ['galleryFullscreen', 'Fullscreen'],
].map(([name, label, initialValue = false]) => ['FieldRadio', {
  name,
  label,
  initialValue,
  block: true,
  choices: [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ],
}]);

const fieldGalleryZoom = ['FieldRadio', {
  name: 'galleryZoom',
  label: 'Zoom',
  initialValue: 'IN_PLACE',
  block: true,
  choices: [
    { label: 'None', value: 'NONE' },
    { label: 'In Place', value: 'IN_PLACE' },
    { label: 'Fullscreen', value: 'FULLSCREEN' },
  ],
}];

const fieldGalleryOverflow = ['FieldRadio', {
  name: 'galleryOverflow',
  label: 'Overflow',
  initialValue: 'FADED',
  block: true,
  choices: [
    { label: 'Visible', value: 'VISIBLE' },
    { label: 'Faded', value: 'FADED' },
    { label: 'Hidden', value: 'HIDDEN' },
  ],
}];

export const [
  fieldsStyleColorsLight,
  fieldsStyleColorsDark,
] = [
  ['Light'],
  ['Dark'],
].map(([suffix]) => [
  asLocalStorageField(['FieldTitleToggle', {
    title: suffix,
    name: `showStyleColors${suffix}`,
    getAnnotation: createGetAnnotation(`styleColors${suffix}`),
    subtitle: `Color overrides for ${suffix} theme`,
    size: 'medium',
    initialValue: false,
  }]),
  ['FieldSortableList', {
    name: `styleColors${suffix}`,
    label: null,
    condensed: true,
    head: 'horizontal',
    headSmall: 'vertical',
    shouldRenderPlaceholder: true,
    placeholderContent: 'Add color overrides using the button below...',
    addButtonLabel: 'Add Color Override',
    hidden: [['condition.fieldIsNotTrue', `showStyleColors${suffix}`]],
    supportDuplicate: true,
    fields: [
      getFilterWithCol(['FieldSelect', {
        name: 'context',
        label: null,
        placeholder: 'Section',
        choices: Types.STORE_COLOR_CONTEXTS,
      }], 8),
      getFilterWithCol(['FieldSelect', {
        name: 'property',
        label: null,
        placeholder: 'Property',
        renderChoices: (field, props) => {
          const context = props.form.getFieldValue('context');
          const choices = (
            Types.STORE_COLOR_CONTEXTS_MAP[context]?.choices || [{
              label: 'N/A',
              value: 'n/a',
            }]
          );
          if (!choices) {
            return null;
          }
          return choices.map(
            choice => props.renderChoice(choice, field, props)
          );
        },
      }], 8),
      getFilterWithCol(['FieldColorPicker', {
        name: 'color',
        label: null,
        placeholder: 'Color',
        disableAlpha: false,
      }], 8),
    ],
  }],
]);

export const fieldStyleTheme = ['FieldRadio', {
  name: 'styleTheme',
  label: 'Theme',
  initialValue: 'light',
  choices: [
    {
      value: 'light',
      label: 'Light',
      icon: '/admin/assets/icons/mode-light.png',
    },
    {
      value: 'dark',
      label: 'Dark',
      icon: '/admin/assets/icons/mode-dark.png',
    },
    {
      value: 'auto',
      label: 'Auto',
      icon: '/admin/assets/icons/mode-auto.png',
    },
  ],
  block: true,
}];

export const fieldStyleIconsStyle = ['FieldRadio', {
  name: 'styleIconsStyle',
  label: 'Icons Style',
  initialValue: 'line',
  choices: [
    { value: 'line', label: 'Line' },
    { value: 'solid', label: 'Solid' },
    { value: 'duotone', label: 'Duotone' },
    { value: 'duotoneOffset', label: 'Duotone Offset' },
  ],
  block: true,
}];

export const fieldStyleButtonStyle = ['FieldSelect', {
  name: 'styleButtonStyle',
  label: 'Button Style',
  initialValue: 'fade',
  choices: [
    { value: 'fade', label: 'Fade' },
    { value: 'accent', label: 'Accent' },
    { value: 'pulse', label: 'Pulse' },
    { value: 'reveal', label: 'Reveal' },
    { value: 'fill', label: 'Fill' },
    { value: 'swipe', label: 'Swipe' },
    { value: 'press', label: 'Press' },
    { value: 'oval', label: 'Oval' },
    { value: 'icon', label: 'Icon' },
  ],
}];

export const fieldStyleButtonSize = ['FieldSelect', {
  name: 'styleButtonSize',
  label: 'Button Size',
  initialValue: 'medium',
  choices: [
    { value: 'small', label: 'Small' },
    { value: 'medium', label: 'Medium' },
    { value: 'large', label: 'Large' },
  ],
}];

export const fieldStyleTransitionStyle = ['FieldSelect', {
  name: 'styleTransitionStyle',
  label: 'Transition Style',
  initialValue: 'springy',
  choices: [
    {
      value: 'smooth',
      label: 'Smooth',
      icon: '/admin/assets/icons/transition-smooth.png',
    },
    {
      value: 'snappy',
      label: 'Snappy',
      icon: '/admin/assets/icons/transition-snappy.png',
    },
    {
      value: 'springy',
      label: 'Springy',
      icon: '/admin/assets/icons/transition-springy.png',
    },
  ],
}];

export const fieldStyleRoundness = ['FieldRadio', {
  name: 'styleRoundness',
  label: 'Roundness',
  choices: [
    {
      value: 'none',
      label: 'Straight',
      icon: '/admin/assets/icons/roundness-none.png',
    },
    {
      value: 'rounded',
      label: 'Rounded',
      icon: '/admin/assets/icons/roundness-rounded.png',
    },
    {
      value: 'round',
      label: 'Round',
      icon: '/admin/assets/icons/roundness-round.png',
    },
  ],
  block: true,
}];

export const fieldStyleCss = ['FieldCodeEditor', {
  name: 'styleCss',
  label: 'Custom CSS',
  placeholder: '',
  defaultLanguage: 'css',
  minHeight: '600px',
  skip: [
    viewerIsNotAdmin,
  ],
}];

export const fieldStyleThemeObject = ['FieldCodeEditor', {
  name: 'styleThemeObject',
  label: 'Theme Object',
  prepareValueForInput: value => (
      isPlainObject(value)
    ? JSON.stringify(value, null, '  ')
    : value
  ),
  rules: [
    ['validation.isRequired'],
    ['validation.isJsonString'],
  ],
  defaultLanguage: 'json',
  minHeight: '600px',
}];

// const StyleThemeObjectExampleCollapse = styled(AntdCollapse)`
//   background: transparent;
//   margin-top: -20px;
//   code {
//     font-size: 70%;
//   }
// `;

// export const fieldStyleThemeObjectExample = ['FieldReact', {
//   label: null,
//   virtual: [() => true],
//   renderContent: () => (
//     <StyleThemeObjectExampleCollapse>
//       <StyleThemeObjectExampleCollapse.Panel header="Example">
//         <pre>
//           <code>
//             {styleThemeObjectExampleJSON}
//           </code>
//         </pre>
//       </StyleThemeObjectExampleCollapse.Panel>
//     </StyleThemeObjectExampleCollapse>
//   ),
// }];

const FONT_PREVIEW_LANGUAGE_CONTENT = {
  en: {
    title: 'This Is <strong>The Title</strong>',
    label: 'This is a <strong>label</strong>',
    body: [
      // eslint-disable-next-line max-len
      'And this is how your body text will look like, with the fonts you chose. Both title and body fonts come in regular and ',
      '<strong>bold variants</strong>.',
    ].join(''),
  },
  ar: {
    title: 'هذا هو <strong/>العنوان<strong>',
    label: 'هذا هو <strong> تصنيف </ strong>',
    body: [
      '.<strong>متغيرات جريئة</strong>',
      // eslint-disable-next-line max-len
      'وهذا ما سيبدو عليه نصك ، بالخطوط التي اخترتها. يأتي كل من خطوط العنوان والجسم بتنسيق منتظم و ',
    ].join(''),
  },
};

const FONT_PREVIEW_TEXT_TRANSFORM_MAP = {
  NONE: 'initial',
  CAPITALIZE: 'capitalize',
  UPPERCASE: 'uppercase',
  LOWERCASE: 'lowercase',
};

const FontLabelHTML = ({
  fontFamily,
  fontWeight = '400',
  ...props
}) => {
  useGoogleFonts([{
    family: fontFamily,
    styles: [fontWeight],
  }]);
  return (
    <div
      {...props}
      style={{ fontFamily, fontWeight }}
    />
  );
};

const FontLabel = styled(FontLabelHTML)`
  .ant-select-dropdown-menu-item & {
    padding: 5px 12px;
  }
`;

export const fieldFontPreviewRaw = (({
  Wrapper,
  // eslint-disable-next-line no-unused-vars
  WrapperHead,
  Component,
}) => ['FieldReact', {
  label: null,
  renderContent: props => (
    <Component WrapperComponent={Wrapper} {...props} />
  ),
}])({
  Wrapper: styled.div`
    ${({
      titleFont,
      bodyFont,
      labelFont,
    }) => css`
      position: relative;
      /* background-color: #fafafa; */
      border: 1px solid ${({ theme }) => theme.less.borderColor};
      border-radius: 15px;
      overflow: hidden;
      > .font-preview-head {
        display: flex;
        align-items: center;
        padding: 0px 15px;
        width: 100%;
        height: 30px;
        border-bottom: 1px solid ${({ theme }) => theme.less.borderColor};
        background: white;
        /* box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05); */
        gap: 10px;
        background: #fafafa;
        .font-preview-head-button {
          width: 10px;
          height: 10px;
          border-radius: 10px;
          border: 1px solid ${({ theme }) => theme.less.borderColor};
        }
        > .font-preview-head-tab {
          border-radius: 10px;
          border-bottom-left-radius: 0px;
          border-bottom-right-radius: 0px;
          background: white;
          height: 25px;
          align-self: flex-end;
          transform: translate(5px, 1px);
          width: 25%;
          border: 1px solid ${({ theme }) => theme.less.borderColor};
          border-bottom: 0px;
        }
        > .font-preview-head-space {
          display: flex;
          flex: 1;
        }
      }
      > .font-preview-body {
        padding: 20px;
        padding-top: 15px;
        h1:focus-visible, p:focus-visible {
          outline: none;
        }
        h1 {
          color: ${({ theme }) => theme.less.textColor};
          font-family: ${titleFont.family};
          font-size: ${titleFont.scaling * 26}px;
          font-weight: ${titleFont.variantNormal};
          text-transform: ${titleFont.textTransform};
          letter-spacing: ${titleFont.letterSpacing};
          strong {
            font-weight: ${titleFont.variantBold};
          }
        }
        p {
          font-family: ${bodyFont.family};
          font-size: ${bodyFont.scaling * 16}px;
          font-weight: ${bodyFont.variantNormal};
          margin-bottom: 0px;
          text-transform: ${bodyFont.textTransform};
          letter-spacing: ${bodyFont.letterSpacing};
          strong {
            font-weight: ${bodyFont.variantBold};
          }
        }
        div.font-preview-body-label {
          margin-top: 18px;
          font-family: ${labelFont.family};
          font-size: ${labelFont.scaling * 16}px;
          font-weight: ${labelFont.variantNormal};
          margin-bottom: 0px;
          text-transform: ${labelFont.textTransform};
          letter-spacing: ${labelFont.letterSpacing};
          strong {
            font-weight: ${labelFont.variantBold};
          }
        }
      }
    `}
  `,
  WrapperHead: styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 30px;
    border-bottom: 1px solid ${({ theme }) => theme.less.borderColor};
    background: white;
  `,
  // eslint-disable-next-line no-unused-vars
  Component: ({ className, children, form, WrapperComponent, data }) => {
    const convertDefault = v => v;
    const convertFamilyName = v => v.replace(/\+/g, ' ');
    const convertTextTransform = v => (
      FONT_PREVIEW_TEXT_TRANSFORM_MAP[v] || 'initial'
    );
    const convertLetterSpacing = v => (
      !v ? '0px' : v
    );
    const titleRef = useRef();
    const bodyRef = useRef();
    const labelRef = useRef();
    // const language = data?.language._id;
    const language = 'en';
    // const languageDirection = data?.language?.direction;
    const languageDirection = 'ltr';
    const [
      titleFont,
      bodyFont,
      labelFont,
    ] = [
      ['styleFontTitle'],
      ['styleFontBody'],
      ['styleFontLabel', {
        textTransform: 'UPPERCASE',
        letterSpacing: '3px',
      }],
    ].map(([prefix, overrides = {}]) => (
      [
        ['family', 'sans-serif', convertFamilyName],
        ['scaling', 1, convertDefault],
        ['variantNormal', '400', convertDefault],
        ['variantBold', '400', convertDefault],
        ['textTransform', 'NONE', convertTextTransform],
        ['letterSpacing', '0px', convertLetterSpacing],
      ].reduce(
        (agr, [name, defaultValue, convert]) => {
          agr[name] = convert(
            form.getFieldValue(`${prefix}.${name}`)
            || overrides[name]
            || defaultValue,
          );
          return agr;
        },
        {},
      )
    ));
    useGoogleFonts(
      [
        titleFont,
        bodyFont,
        labelFont,
      ]
      .map((currentFont) => ({
        family: currentFont.family,
        styles: (
            currentFont.variantNormal === currentFont.variantBold
          ? [currentFont.variantNormal]
          : [currentFont.variantNormal, currentFont.variantBold]
        ),
      })),
    );
    useEffect(
      () => {
        [
          [titleRef, 'title'],
          [bodyRef, 'body'],
          [labelRef, 'label'],
        ].forEach(([ref, key]) => {
          ref.current.innerHTML = FONT_PREVIEW_LANGUAGE_CONTENT[language][key];
        });
      },
      [language],
    );
    return (
      <WrapperComponent
        className={className}
        titleFont={titleFont}
        bodyFont={bodyFont}
        labelFont={labelFont}
      >
        <div className="font-preview-head">
          <div className="font-preview-head-button" />
          <div className="font-preview-head-button" />
          <div className="font-preview-head-button" />
          <div className="font-preview-head-tab" />
          <div className="font-preview-head-space" />
        </div>
        <div
          className="font-preview-body"
          style={{ direction: languageDirection }}
        >
          {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
          <h1 contentEditable ref={titleRef} />
          <p contentEditable ref={bodyRef} />
          <div
            contentEditable
            ref={labelRef}
            className="font-preview-body-label"
          />
        </div>
      </WrapperComponent>
    );
  },
});

export const fieldFontPreview = fieldFontPreviewRaw;

const SelectVariant = styled(({
  className,
  value,
  children,
  onChange,
  preferences,
  ...props
}) => {
  useEffect(
    () => {
      const timeout = setTimeout(
        () => {
          const v = value ? value.value : value;
          const values = children.map(choice => choice.props.value);
          if (!values.includes(v)) {
            preferences.find((n) => {
              n = `${n * 100}`;
              if (values.includes(n)) {
                onChange(n);
                return true;
              }
              return false;
            });
          }
        },
        500,
      );
      return () => clearTimeout(timeout);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value, children, onChange],
  );
  return (
    <AntdSelect
      {...props}
      value={value}
      onChange={onChange}
      dropdownClassName={className}
    >
      {children}
    </AntdSelect>
  );
})`
  .ant-select-dropdown-menu-item {
    padding: 0px;
  }
`;

export const [
  fieldsStyleFontTitle,
  fieldsStyleFontBody,
  fieldsStyleFontLabel,
] = [
  ['styleFontTitle'],
  ['styleFontBody'],
  ['styleFontLabel', {
    textTransform: {
      initialValue: 'UPPERCASE',
    },
    letterSpacing: {
      initialValue: '3px',
      placeholder: '3px',
    },
  }],
].reduce(
  (agr, [name, fieldOverrides = {}]) => {
    agr.push([
      ['FieldConnectionSelect', {
        name: `${name}.family`,
        placeholder: 'Select Font Family',
        label: 'Font Family',
        initialValue: 'default',
        url: '/fonts',
        extractChoicesQuery: (search, props) => ({
          name: search,
          language: props?.data?.language,
          ...props.getExtraQueryProps(props),
        }),
        extractValueQuery: (value, props) => ({
          _id: value,
          ...props.getExtraQueryProps(props),
        }),
        handleChange: (value, props) => {
          props.form.setFieldsValue({
            [`${name}.variantNormal`]: 'none',
            [`${name}.variantBold`]: 'none',
          });
        },
        formItemConfig: { style: { marginBottom: '23px' } },
        rules: [['validation.isRequired']],
        // eslint-disable-next-line no-unused-vars
        renderChoiceLabel: (choice, field, props) => (
          <FontLabel fontFamily={choice.label}>
            {choice.label}
          </FontLabel>
        ),
        // eslint-disable-next-line arrow-body-style
        Component: styled(({ className, ...props }) => {
          return <AntdSelect {...props} dropdownClassName={className} />;
        })`
          .ant-select-dropdown-menu-item {
            padding: 0px;
          }
        `,
      }],
      ['FieldText', {
        name: `${name}.scaling`,
        label: 'Scaling',
        type: 'number',
        align: 'right',
        initialValue: 1,
        rules: [
          ['validation.isRequired'],
          [(config = {}) => ({
            type: 'number',
            min: 0.8,
            max: 1.5,
            message: 'Scaling must be a number between 0.8 and 1.5',
            ...config,
          })],
        ],
      }],
      ['FieldConnectionSelect', {
        name: `${name}.variantNormal`,
        placeholder: 'Select Font Variant',
        label: 'Normal Weight',
        initialValue: 'default',
        url: '/fonts/:id/variants',
        extractChoicesQuery: (search, props) => ({
          id: props.form.getFieldValue(`${name}.family`),
          ...props.getExtraQueryProps(props),
        }),
        extractValueQuery: (value, props) => ({
          id: props.form.getFieldValue(`${name}.family`),
          _id: value,
          ...props.getExtraQueryProps(props),
        }),
        showSearch: false,
        rules: [['validation.isRequired']],
        renderChoiceLabel: (choice, field, props) => (
          <FontLabel
            fontFamily={props.form.getFieldValue(`${name}.family`)}
            fontWeight={choice.label}
          >
            {choice.label}
          </FontLabel>
        ),
        Component: props => (
          <SelectVariant
            {...props}
            preferences={[4, 3, 2, 1, 5, 6, 7, 8, 9]}
          />
        ),
      }],
      ['FieldConnectionSelect', {
        name: `${name}.variantBold`,
        placeholder: 'Select Font Variant',
        label: 'Bold Weight',
        initialValue: 'default',
        url: '/fonts/:id/variants',
        extractChoicesQuery: (search, props) => ({
          id: props.form.getFieldValue(`${name}.family`),
          ...props.getExtraQueryProps(props),
        }),
        extractValueQuery: (value, props) => ({
          id: props.form.getFieldValue(`${name}.family`),
          _id: value,
          ...props.getExtraQueryProps(props),
        }),
        showSearch: false,
        rules: [['validation.isRequired']],
        renderChoiceLabel: (choice, field, props) => (
          <FontLabel
            fontFamily={props.form.getFieldValue(`${name}.family`)}
            fontWeight={choice.label}
          >
            {choice.label}
          </FontLabel>
        ),
        Component: props => (
          <SelectVariant
            {...props}
            preferences={[6, 7, 8, 9, 5, 4, 3, 2, 1]}
          />
        ),
      }],
      ['FieldSelect', {
        name: `${name}.textTransform`,
        label: 'Text Transform',
        initialValue: 'NONE',
        choices: ['NONE', 'CAPITALIZE', 'UPPERCASE', 'LOWERCASE'].map(
          value => ({
            value,
            label: `${value[0]}${value.slice(1).toLowerCase()}`,
          }),
        ),
        ...(fieldOverrides.textTransform || {}),
      }],
      ['FieldText', {
        name: `${name}.letterSpacing`,
        label: 'Letter Spacing',
        align: 'right',
        initialValue: '0px',
        placeholder: '0px',
        ...(fieldOverrides.letterSpacing || {}),
      }],
    ]);
    return agr;
  },
  [],
);

export const fieldEmail = Admin.compileFromLibrary(['FieldText', {
  name: 'email',
  autoComplete: 'new-email',
  rules: [['validation.isRequired'], ['validation.isEmail']],
}]);

export const fieldPhoneNumberString = Admin.compileFromLibrary(['FieldText', {
  name: 'phoneNumberString',
  label: 'Phone Number',
  rules: [['validation.isRequired']],
}]);

export const fieldPhoneNumberPickupString = Admin.compileFromLibrary(
  ['FieldText', {
    name: 'phoneNumberPickupString',
    label: 'Fulfillment Support Phone Number',
    skip: [storeTypeNotMerchantNorReseller],
  }],
);

export const fieldAddress = Admin.compileFromLibrary(['FieldGoogleAddress', {
  name: 'address',
  label: 'Address',
  rules: [['validation.isRequired']],
  skip: [storeTypeNotMerchantNorReseller],
  extraGeocodingParams: {},
  extraAutocompleteParams: {},
}]);

export const fieldHours = Admin.compileFromLibrary(['FieldWorkingHours', {
  name: 'hours',
  label: 'Working Hours',
  help: [
    'Used to disable new orders being placed via',
    'Store or Packman RUSH shipping with local storage option.',
  ].join(' '),
  initialValue: [...Types.DEFAULT_WORKING_HOURS],
  rules: [['validation.isRequired']],
  skip: [storeTypeNotMerchant],
}]);

export const fieldFacebookHref = ['FieldText', {
  name: 'facebookHref',
  label: 'Facebook URL',
}];

export const fieldInstagramHref = ['FieldText', {
  name: 'instagramHref',
  label: 'Instagram URL',
}];

export const fieldTwitterHref = ['FieldText', {
  name: 'twitterHref',
  label: 'Twitter URL',
}];

export const fieldWhatsappHref = ['FieldText', {
  name: 'whatsappHref',
  label: 'WhatsApp URL',
}];

export const fieldTiktokHref = ['FieldText', {
  name: 'tiktokHref',
  label: 'TikTok URL',
}];

export const fieldSnapchatHref = ['FieldText', {
  name: 'snapchatHref',
  label: 'Snapchat URL',
}];

export const fieldYoutubeHref = ['FieldText', {
  name: 'youtubeHref',
  label: 'YouTube URL',
}];

export const fieldCookiesConsentActive = Admin.compileFromLibrary([
  'FieldSwitch',
  {
    name: 'cookiesConsentActive',
    label: 'Use Cookies Consent Form?',
    required: true,
    initialValue: false,
  },
]);

export const fieldConsentActive = Admin.compileFromLibrary(['FieldSwitch', {
  name: 'consent.active',
  label: 'Use Consent Screen?',
  required: true,
  initialValue: false,
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_website_consent',
  ]],
}]);

export const fieldConsentTitle = Admin.compileFromLibrary(['FieldText', {
  name: 'consent.title',
  label: 'Title',
  hidden: [
    consentScreenIsActive,
    [
      'condition.fieldIsNotTrue',
      'show_fields_website_consent',
    ],
  ],
  // skip: [consentScreenIsActive],
  i18nTranslatable: true,
}]);

export const fieldConsentBody = Admin.compileFromLibrary(['FieldTextArea', {
  name: 'consent.body',
  label: 'Body',
  autoSize: { minRows: 3 },
  hidden: [
    consentScreenIsActive,
    [
      'condition.fieldIsNotTrue',
      'show_fields_website_consent',
    ],
  ],
  // skip: [consentScreenIsActive],
  i18nTranslatable: true,
}]);

export const fieldConsentLabelConfirm = Admin.compileFromLibrary(['FieldText', {
  name: 'consent.labelConfirm',
  label: 'Confirm Label',
  hidden: [
    consentScreenIsActive,
    [
      'condition.fieldIsNotTrue',
      'show_fields_website_consent',
    ],
  ],
  // skip: [consentScreenIsActive],
  i18nTranslatable: true,
}]);

export const fieldConsentLabelDeny = Admin.compileFromLibrary(['FieldText', {
  name: 'consent.labelDeny',
  label: 'Leave Label',
  hidden: [
    consentScreenIsActive,
    [
      'condition.fieldIsNotTrue',
      'show_fields_website_consent',
    ],
  ],
  // skip: [consentScreenIsActive],
  i18nTranslatable: true,
}]);

export const fieldsMeta = [
  ['FieldUploadRefs', {
    name: 'metaImage',
    label: 'Image',
    maxCount: 1,
    col: 1,
    accept: 'image/jpg,image/jpeg,image/png',
    transformations: [[
      'GM',
      { command: 'compress', quality: 95, maxWidth: 1100 },
    ]],
  }],
  ['FieldUploadRefs', {
    name: 'metaImagePwa',
    label: 'App Icon',
    maxCount: 1,
    col: 1,
    accept: 'image/jpg,image/jpeg,image/png',
    transformations: [[
      'GM',
      { command: 'compress', quality: 95, maxWidth: 1100 },
    ]],
  }],
  // fieldFavicon,
  ['FieldText', {
    name: 'metaTitle',
    label: 'Title',
  }],
  ['FieldText', {
    name: 'metaDescription',
    label: 'Description',
  }],
  ['FieldText', {
    name: 'metaKeywordsString',
    label: 'Keywords',
  }],
  ['FieldText', {
    name: 'metaGoogleSiteVerification',
    label: 'google Site Verification',
  }],
  ['FieldText', {
    name: 'metaGoogleSiteVerification',
    label: 'google Site Verification',
  }],
  ['FieldColorPicker', {
    name: 'metaColorPwa',
    label: 'App Color',
    disableAlpha: true,
    rules: [[(config = {}) => ({
      validator: (rule, value, cb) => (cb(
        (!value || !value.length)
        ? undefined
        : /^(hsla?\(|#)/.test(value)
        ? undefined
        : rule.message
      )),
      // eslint-disable-next-line max-len
      message: 'Color must be either hsl (eg. hsl(327, 46%, 46%)) or a HEX String (eg. #AA407A)',
      ...config,
  })]],
  }],
].map(field => Admin.compileFromLibrary([field[0], {
  ...field[1],
  hidden: [[
    'condition.fieldIsNotTrue',
    'show_fields_social_meta',
  ]],
}]));

export const fieldsIntegrations = [
  Admin.compileFromLibrary(
    ['FieldTitle', {
      title: 'Simple Analytics',
      hidden: [[
        'condition.fieldIsNotTrue',
        'show_fields_website_integrations',
      ]],
      skip: [
        () => true,
        viewerIsNotAdmin,
      ],
    }],
  ),
  Admin.compileFromLibrary(
    ['Action', {
      name: 'open-simple-analytics',
      title: 'Open Dashboard',
      hidden: [[
        'condition.fieldIsNotTrue',
        'show_fields_website_integrations',
      ]],
      onClick: (props) => {
        clickAnchor(`https://simpleanalytics.com/${
          props.data.integrations?.simpleAnalytics?.hostname
        }`, { target: '_blank' });
      },
      ghost: true,
      skip: [
        () => true,
        viewerIsNotAdmin,
      ],
      style: { width: '100%' },
    }],
  ),
  ...[
    [
      'metaPixel',
      'Meta Pixel',
      [
        ['FieldTextAreaMonospace', {
          name: 'trackingCode',
          label: 'Pixel Code Snippet',
          autoSize: {
            minRows: 4,
            maxRows: 4,
          },
        }],
      ],
    ], [
      'snapchatPixel',
      'Snapchat Pixel',
      [
        ['FieldTextAreaMonospace', {
          name: 'trackingCode',
          label: 'Snapchat Code Snippet',
          autoSize: {
            minRows: 4,
            maxRows: 4,
          },
        }],
      ],
    ], [
      'tiktokPixel',
      'TikTok Pixel',
      [
        ['FieldTextAreaMonospace', {
          name: 'trackingCode',
          label: 'TikTok Code Snippet',
          autoSize: {
            minRows: 4,
            maxRows: 4,
          },
        }],
      ],
    ], [
      'googleAnalytics',
      'Google Analytics 4 (GA4)',
      [
        ['FieldTextAreaMonospace', {
          name: 'trackingCode',
          label: 'Google Analytics Tag Code Snippet',
          autoSize: {
            minRows: 4,
            maxRows: 4,
          },
        }],
      ],
    ], [
      'googleTagManager',
      'Google Tag Manager',
      [
        ['FieldText', {
          name: 'containerId',
          label: 'Google Tag Manager Container ID',
        }],
      ],
      // {
      //   skip: [viewerIsNotThehiveRsAdmin],
      // },
    ], [
      'whatsApp',
      'WhatsApp Chat',
      [
        ['FieldText', {
          name: 'phoneNumber',
          label: 'Phone Number',
        }],
      ],
    ], [
      'openId',
      'OpenID Customer Login',
      [
        ['FieldText', {
          name: 'backend',
          label: 'Backend',
        }],
        ['FieldText', {
          name: 'failureUri',
          label: 'Error Page Url',
        }],
      ],
      {
        skip: [viewerIsNotThehiveRsAdmin],
      },
    ],
  ].reduce(
    (agr, [
      id,
      title,
      fields = [],
      globalConfig = {},
    ]) => {
      const isNotSupported = Admin.compileFromLibrary([
        'condition.testFieldValue',
        `integrations.${id}.supported`,
        '!==',
        true,
      ]);
      agr.push(...Admin.compileFromLibrary(
        [
          ['FieldTitle', {
            title,
            skip: globalConfig.skip,
            hidden: [[
              'condition.fieldIsNotTrue',
              'show_fields_website_integrations',
            ]],
          }],
          ['FieldRadio', {
            name: `integrations.${id}.supported`,
            label: null,
            initialValue: false,
            block: true,
            choices: [
              { label: 'Enabled', value: true },
              { label: 'Disabled', value: false },
            ],
            skip: globalConfig.skip,
            hidden: [[
              'condition.fieldIsNotTrue',
              'show_fields_website_integrations',
            ]],
          }],
          ...fields.map(([type, config = {}]) => [type, {
            ...globalConfig,
            ...config,
            name: `integrations.${id}.${config.name}`,
            skip: [
              ...(globalConfig.skip || []),
              ...(config.skip || []),
              isNotSupported,
            ],
            hidden: [[
              'condition.fieldIsNotTrue',
              'show_fields_website_integrations',
            ]],
          }]),
        ],
        true,
      ));
      return agr;
    },
    []
  ),
];

export const fieldTrnActive = Admin.compileFromLibrary(['FieldSwitch', {
  name: 'trn.active',
  label: 'Use TRN?',
  required: true,
  initialValue: false,
  skip: [viewerIsNotAdmin, storeTypeNotMerchantNorReseller],
}]);

export const fieldTrnNumber = Admin.compileFromLibrary(['FieldText', {
  name: 'trn.number',
  label: 'TRN Value',
  required: true,
  skip: [
    viewerIsNotAdmin,
    storeTypeNotMerchantNorReseller,
    trnIsActive,
  ],
}]);

export const fieldPoliciesTnc = Admin.compileFromLibrary(['FieldUploadRefs', {
  name: 'policies.tnc',
  label: 'Custom Terms and Conditions Policy',
  listType: 'text',
  accept: 'application/pdf',
  skip: [storeTypeNotMerchantNorReseller],
}]);

export const fieldDocuments = Admin.compileFromLibrary(['FieldUploadRefs', {
  name: 'documents',
  label: 'Documents',
  listType: 'text',
  maxCount: 10,
  accept: 'application/pdf',
  skip: [storeTypeNotMerchantNorReseller],
  showUploadList: {
    showRemoveIcon: window.location.hostname === 'localhost',
  },
}]);

export const fieldDocumentPersonal = ['FieldUploadRefs', {
  name: 'documentPersonal',
  label: 'Personal Document',
  listType: 'text',
  col: { xs: 24, lg: 12 },
  maxCount: 1,
  accept: 'application/pdf',
  skip: [storeTypeNotMerchantNorReseller],
  disabled: [
    props => props.data?.active && props.viewer?.role !== 'ADMIN',
  ],
  help: 'Your ID, Passport or Driver License',
}];

export const fieldDocumentPersonalExpirationDate = ['FieldDatePicker', {
  name: 'documentPersonalExpirationDate',
  label: 'Personal Document Expiration Date',
  skip: [storeTypeNotMerchantNorReseller],
  col: { xs: 24, lg: 12 },
  prepareValueForInput: value => moment(value),
}];

export const fieldDocumentBusiness = ['FieldUploadRefs', {
  name: 'documentBusiness',
  label: 'Business Document',
  listType: 'text',
  col: { xs: 24, lg: 12 },
  maxCount: 1,
  accept: 'application/pdf',
  skip: [storeTypeNotMerchantNorReseller],
  disabled: [
    props => props.data?.active && props.viewer?.role !== 'ADMIN',
  ],
  help: 'Your Business License or Commercial Registration',
}];

export const fieldDocumentBusinessExpirationDate = ['FieldDatePicker', {
  name: 'documentBusinessExpirationDate',
  label: 'Business Document Expiration Date',
  skip: [storeTypeNotMerchantNorReseller],
  col: { xs: 24, lg: 12 },
  prepareValueForInput: value => moment(value),
}];

export const fieldStrictTermsAndConditions = Admin.compileFromLibrary(
  ['FieldRadio', {
    name: 'strictTermsAndConditions',
    label: 'Use Strict Terms And Conditions',
    block: true,
    choices: [
      { label: 'Enabled', value: true },
      { label: 'Disabled', value: false },
    ],
  }]
);

export const fieldShippingTitle = ['FieldTitle', {
  title: 'Shipping',
}];

export const fieldShippingAutoReadyForPickupFromLocalStorage = (
  Admin.compileFromLibrary(getFilterWithCol(['FieldRadio', {
    name: 'shippingAutoReadyForPickupFromLocalStorage',
    label: 'Order are marked as Ready For Pickup',
    skip: [storeTypeNotMerchant],
    // eslint-disable-next-line max-len
    help: `Manual mode applies to orders shipping from the Local Storage when the preferred shipping is either ${
      Types.SHIPPING_PROVIDER_MANUAL_READY_FOR_PICKUP_SUPPORT.reduce(
        (agr, shippingProvider, index, array) => {
          agr.push(Types.SHIPPING_PROVIDER_LABELS_MAP[shippingProvider]);
          if (index < array.length - 2) {
            agr.push(', ');
          } else if (index === array.length - 2) {
            agr.push(' or ');
          }
          return agr;
        },
        [],
      ).join('')
    }.`,
    initialValue: true,
    choices: [
      { label: 'Immediately', value: true },
      { label: 'Manually', value: false },
    ],
    block: true,
  }], 12))
);

export const fieldShippingScheduledDeliverySupport = (
  Admin.compileFromLibrary(getFilterWithCol(['FieldRadio', {
    name: 'shippingScheduledDeliverySupport',
    label: 'Support Scheduled Orders',
    // eslint-disable-next-line max-len
    help: `Offered when the preffered shipping is either ${
      Types.SHIPPING_PROVIDER_SCHEDULED_DELIVERY_SUPPORT.reduce(
        (agr, shippingProvider, index, array) => {
          agr.push(Types.SHIPPING_PROVIDER_LABELS_MAP[shippingProvider]);
          if (index < array.length - 2) {
            agr.push(', ');
          } else if (index === array.length - 2) {
            agr.push(' or ');
          }
          return agr;
        },
        [],
      ).join('')
    }.`,
    skip: [storeTypeNotMerchantNorReseller],
    initialValue: false,
    choices: [
      { label: 'Disabled', value: false },
      { label: 'Enabled', value: true },
    ],
    block: true,
  }], 12))
);

// export const fieldShippingMethodsTitle = ['FieldTitle', {
//   title: 'Shipping Methods',
// }];

export const fieldShippingCountriesAvailability = ['FieldRadio', {
  name: 'shippingCountriesAvailability',
  label: 'Shipping To Countries',
  initialValue: 'ALL',
  block: true,
  choices: [{
    value: 'ALL',
    label: 'All',
  }, {
    value: 'BLACKLIST',
    label: 'Blacklist',
  }, {
    value: 'WHITELIST',
    label: 'Whitelist',
  }],
}];

export const fieldShippingCountriesList = ['FieldSelect', {
  name: 'shippingCountriesList',
  label: 'Countries List',
  choices: Types.COUNTRIES.map(({ name, iso3a2 }) => ({
    label: name,
    value: iso3a2,
  })),
  optionFilterProp: 'children',
  skip: [
    [
      'condition.testFieldValue',
      'shippingCountriesAvailability',
      '===',
      'ALL',
    ],
  ],
  mode: 'multiple',
}];

export const fieldsShipping = [
  [
    ShippingProvider.PACKMAN_SHOP,
    shippingPackmanShopNotSupported,
    { disabled: [viewerIsNotAdmin] },
    [
      ['FieldTable', {
        name: `shipping.${ShippingProvider.PACKMAN_SHOP}.methods`,
        label: 'Methods available',
        rules: [['validation.isRequired']],
        table: { showHeader: false, rowKey: 'method', size: 'small' },
        prepareValueForInput: (value = {}) => (
          Types.SHIPPING_PROVIDER_METHOD_MAP[ShippingProvider.PACKMAN_SHOP]
          .reduce(
            (agr1, method) => {
              const label = Types.SHIPPING_METHOD_LABELS_MAP[method];
              if (value && value[method]) {
                agr1.push({
                  shippingCompany: null,
                  ...value[method],
                  method,
                  label,
                });
              } else {
                agr1.push({
                  method,
                  label,
                  supported: false,
                  shippingCompany: null,
                });
              }
              return agr1;
            },
            [],
          )
        ),
        prepareValueForForm: value => value.reduce(
          (agr1, row) => {
            agr1[row.method] = {
              supported: !!row.supported,
              shippingCompany: row.shippingCompany,
            };
            return agr1;
          },
          {},
        ),
        columns: [{
          key: 'supported',
          align: 'center',
          width: '50px',
          fields: [{
            name: 'supported',
            ComponentInput: InputCheckbox,
            props: {
              size: 'small',
            },
          }],
        }, {
          key: 'label',
          getLabel: ({ label }) => label,
        }, {
          key: 'shippingCompany',
          width: '50%',
          fields: [{
            name: 'shippingCompany',
            ComponentInput: InputFormField,
            getProps: (field, value, props, inputProps) => {
              const name = inputProps['data-input-name'];
              return {
                ...inputProps,
                fieldName: 'FieldConnectionSelect',
                fieldConfig: {
                  name: 'shippingCompany',
                  label: null,
                  url: '/shippingcompanies',
                  placeholder: 'Shipping Company',
                },
                onChange: (inputValue) => {
                  if (inputValue && inputValue.nativeEvent) {
                    inputValue = inputValue.target.value;
                  }
                  props.onFormChange(
                    props.rowIndex,
                    name,
                    inputValue,
                  );
                },
                size: 'small',
                value: value[name],
                client: props.fieldProps.client,
                allowClear: true,
              };
            },
          }],
        }],
        skip: [shippingPackmanShopNotSupported],
        disabled: [viewerIsNotAdmin],
      }],
      ['FieldText', {
        name: `shipping.${ShippingProvider.PACKMAN_SHOP}.multiplier`,
        label: 'Multiplier',
        type: 'number',
        skip: [shippingPackmanShopNotSupported, viewerIsNotAdmin],
        virtual: [viewerIsNotAdmin],
        disabled: [viewerIsNotAdmin],
        rules: [
          ['validation.isNumber'],
        ],
      }],
    ],
    {
      skip: [shippingPackmanShopNotSupported],
      disabled: [viewerIsNotAdmin],
      hidden: [viewerIsNotAdmin],
    },
    // { disabled: [viewerIsNotAdmin] },
    {},
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.PACKMAN_SHOP}.payment`,
      // eslint-disable-next-line max-len
      skip: [shippingPackmanShopNotSupported],
      paymentMethods: PAYMENT_METHODS.filter(method => method !== 'COD_CARD'),
      skipPrice: true,
      helpShippingLabel: Types.SHIPPING_PROVIDER_LABELS_MAP[
        ShippingProvider.PACKMAN_SHOP
      ],
    }],
  ],
  [
    ShippingProvider.PACKMAN_RUSH,
    shippingPackmanRushNotSupported,
    { disabled: [viewerIsNotAdmin] },
    [
      ['FieldText', {
        name: `shipping.${ShippingProvider.PACKMAN_RUSH}.multiplier`,
        label: 'Multiplier',
        type: 'number',
        skip: [shippingPackmanRushNotSupported, viewerIsNotAdmin],
        virtual: [viewerIsNotAdmin],
        disabled: [viewerIsNotAdmin],
        rules: [
          ['validation.isNumber'],
        ],
      }],
    ],
    { skip: [shippingPackmanRushNotSupported], disabled: [viewerIsNotAdmin] },
    { disabled: [viewerIsNotAdmin] },
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.PACKMAN_RUSH}.payment`,
      skip: [shippingPackmanRushNotSupported],
      paymentMethods: PAYMENT_METHODS.filter(method => method !== 'COD_CARD'),
      skipPrice: true,
      helpShippingLabel: Types.SHIPPING_PROVIDER_LABELS_MAP[
        ShippingProvider.PACKMAN_RUSH
      ],
    }],
  ],
  [
    ShippingProvider.STORE,
    shippingStoreNotSupported,
    {},
    [
      ['FieldTable', {
        name: `shipping.${ShippingProvider.STORE}.methods`,
        label: 'Methods available',
        rules: [['validation.isRequired']],
        table: { showHeader: false, rowKey: 'method', size: 'small' },
        skip: [shippingStoreNotSupported],
        prepareValueForInput: (value = {}) => (
          Types.SHIPPING_PROVIDER_METHOD_MAP[ShippingProvider.STORE]
          .reduce(
            (agr1, method) => {
              const label = Types.SHIPPING_METHOD_LABELS_MAP[method];
              if (value && value[method]) {
                agr1.push({
                  shippingCompany: null,
                  ...value[method],
                  method,
                  label,
                });
              } else {
                agr1.push({
                  method,
                  label,
                  supported: false,
                  shippingCompany: null,
                });
              }
              return agr1;
            },
            [],
          )
        ),
        prepareValueForForm: value => value.reduce(
          (agr1, row) => {
            agr1[row.method] = {
              supported: !!row.supported,
              shippingCompany: row.shippingCompany,
            };
            return agr1;
          },
          {},
        ),
        columns: [{
          key: 'supported',
          align: 'center',
          width: '50px',
          fields: [{
            name: 'supported',
            ComponentInput: InputCheckbox,
            props: {
              size: 'small',
            },
          }],
        }, {
          key: 'label',
          getLabel: ({ label }) => label,
        // }, {
        //   key: 'shippingCompany',
        //   width: '50%',
        //   hidden: true,
        //   fields: [{
        //     name: 'shippingCompany',
        //     ComponentInput: InputFormField,
        //     getProps: (field, value, props, inputProps) => {
        //       const name = inputProps['data-input-name'];
        //       return {
        //         ...inputProps,
        //         fieldName: 'FieldConnectionSelect',
        //         fieldConfig: {
        //           name: 'shippingCompany',
        //           label: null,
        //           url: '/shippingcompanies',
        //           placeholder: 'Shipping Company',
        //         },
        //         onChange: (inputValue) => {
        //           if (inputValue && inputValue.nativeEvent) {
        //             inputValue = inputValue.target.value;
        //           }
        //           props.onFormChange(
        //             props.rowIndex,
        //             name,
        //             inputValue,
        //           );
        //         },
        //         size: 'small',
        //         value: value[name],
        //         client: props.fieldProps.client,
        //         allowClear: true,
        //       };
        //     },
        //   }],
        }],
        // disabled: [viewerIsNotAdmin],
      }],
      ['FieldText', {
        name: `shipping.${ShippingProvider.STORE}.multiplier`,
        label: 'Multiplier',
        type: 'number',
        skip: [shippingStoreNotSupported, viewerIsNotAdmin],
        virtual: [viewerIsNotAdmin],
        disabled: [viewerIsNotAdmin],
        rules: [
          ['validation.isNumber'],
        ],
      }],
    ],
    {
      skip: [() => true], // Never allow store shipping from our warehouse
      disabled: [viewerIsNotAdmin],
      hidden: [viewerIsNotAdmin],
    },
    {},
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.STORE}.payment`,
      skip: [shippingStoreNotSupported],
      paymentMethods: PAYMENT_METHODS,
      skipPrice: true,
      helpShippingLabel: Types.SHIPPING_PROVIDER_LABELS_MAP[
        ShippingProvider.STORE
      ],
    }],
  ],
  [
    ShippingProvider.STORE_RUSH,
    shippingStoreRushNotSupported,
    {},
    [],
    { skip: [shippingStoreRushNotSupported] },
    {},
    ['FieldSwitch', {
      name: `shipping.${ShippingProvider.STORE_RUSH}.instant`,
      label: 'Instant shipping only?',
      help: 'Disable placing order outside the working hours?',
      initialValue: true,
      rules: [['validation.isRequired']],
      skip: [shippingStoreRushNotSupported],
    }],
    ['FieldProductAttributes', {
      name: `shipping.${ShippingProvider.STORE_RUSH}.attributes`,
      label: 'Shipping disclaimers support and their prices',
      skip: [shippingStoreRushNotSupported],
    }],
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.STORE_RUSH}.payment`,
      skip: [shippingStoreRushNotSupported],
    }],
    ['FieldSortableList', {
      inputId: 'packman-shop-store-shipping-store-zones-repeater',
      name: `shipping.${ShippingProvider.STORE_RUSH}.zones`,
      label: 'Delivery Zones',
      supportDuplicate: true,
      skip: [shippingStoreRushNotSupported],
      fields: [
        ['FieldText', {
          name: 'name',
          label: null,
          placeholder: 'Name',
          col: {
            xs: { span: 24 },
            lg: { span: 12 },
          },
        }],
        ['FieldText', {
          name: 'price',
          label: null,
          type: 'number',
          placeholder: 'Price',
          col: {
            xs: { span: 24 },
            lg: { span: 12 },
          },
        }],
        ['FieldGooglePolygon', {
          name: 'polygon',
          label: null,
          mapContainerHeight: '250px',
          polygonExtraParameters: {
            strokeColor: '#F2C314',
            fillColor: '#F2C31480',
          },
          initialMapConfig: {
            // UAE
            zoom: 6,
            center: {
              lng: 54.71720030880409,
              lat: 24.659754289090323,
            },
            mapId: '6e19c12db80341f8',
            // styles: googleMapStyles,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
          },
        }],
      ],
    }],
  ],
  [
    ShippingProvider.SELF_PICKUP,
    shippingSelfPickupNotSupported,
    { disabled: [viewerIsNotAdmin] },
    [],
    { skip: [shippingSelfPickupNotSupported], disabled: [viewerIsNotAdmin] },
    { skip: [() => true] },
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.SELF_PICKUP}.payment`,
      skip: [shippingSelfPickupNotSupported],
      skipPrice: true,
    }],
  ],
  [
    ShippingProvider.POS,
    shippingPOSNotSupported,
    { disabled: [viewerIsNotAdmin] },
    [],
    { skip: [shippingPOSNotSupported], disabled: [viewerIsNotAdmin] },
    { skip: [() => true] },
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.POS}.payment`,
      skip: [shippingPOSNotSupported],
      skipPrice: true,
    }],
  ],
  [
    ShippingProvider.ABSTRACT,
    [shippingAbstractNotSupported],
    {
      disabled: [() => true],
      skip: [() => false],
      virtual: [() => true],
      initialValue: true,
    },
    [],
    { skip: [() => true] },
    { skip: [() => true] },
    ['FieldPaymentMethods', {
      name: `shipping.${ShippingProvider.ABSTRACT}.payment`,
      skip: [shippingAbstractNotSupported],
      skipPrice: true,
    }],
  ],
].reduce(
  (
    agr,
    [
      provider,
      notSupportedTest,
      switchParams,
      afterSupportedFields,
      storageParams,
      freeShippingParams,
      ...extraFields
    ],
    // eslint-disable-next-line no-unused-vars
    index,
  ) => {
    const supportedName = `shipping.${provider}.supported`;
    const isToggleHidden = Admin.compileFromLibrary([
      'condition.fieldIsNotTrue',
      `show_shipping_${provider}`,
    ]);
    agr.push(
      Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
        name: `show_shipping_${provider}`,
        initialValue: false,
        title: Types.SHIPPING_PROVIDER_LABELS_MAP[provider],
        // size: 'medium',
        getAnnotation: (inputAnnotation, props) => {
          const supported = (
            provider === 'ABSTRACT'
            ? true
            : props.form.getFieldValue(supportedName)
          );
          const storage = (
            provider === 'ABSTRACT'
            ? null
            : props.form.getFieldValue(`shipping.${provider}.storage`)
          );
          return (
            supported
            ? `/ Enabled${
                storage
                ? ` / ${Types.SHIPPING_STORAGE_LABELS_MAP[storage]}`
                : ''
              }`
            : null
          );
        },
        subtitle: Types.SHIPPING_PROVIDER_DESCRIPTIONS_MAP[provider],
        skip: [
          activityNotEdit,
          storeTypeNotMerchantNorReseller,
          ...(switchParams.skip || []),
        ],
      }])),
      Admin.compileFromLibrary(getFilterWithCol(['FieldRadio', {
        name: supportedName,
        label: 'Supported',
        rules: [['validation.isRequired']],
        initialValue: false,
        choices: [
          { value: false, label: 'Disabled' },
          { value: true, label: 'Enabled' },
        ],
        ...switchParams,
        hidden: [
          ...(switchParams.hidden || []),
          isToggleHidden,
        ],
        skip: [
          activityNotEdit,
          storeTypeNotMerchantNorReseller,
          ...(switchParams.skip || []),
        ],
        getCol: (field, props) => {
          if (viewerIsNotAdminCompiled(props)) {
            return { span: 24 };
          }
          return { span: 12 };
        },
        block: true,
      }], 12)),
      Admin.compileFromLibrary(getFilterWithCol(['FieldRadio', {
        name: `shipping.${provider}.storage`,
        label: 'Storage',
        rules: [['validation.isRequired']],
        initialValue: ShippingStorage.LOCAL,
        choices: [{
          value: ShippingStorage.LOCAL,
          label: Types.SHIPPING_STORAGE_LABELS_MAP[ShippingStorage.LOCAL],
        }, {
          value: ShippingStorage.WAREHOUSE,
          label: Types.SHIPPING_STORAGE_LABELS_MAP[ShippingStorage.WAREHOUSE],
        }],
        ...storageParams,
        hidden: [
          ...(storageParams.hidden || []),
          isToggleHidden,
        ],
        skip: [
          activityNotEdit,
          storeTypeNotMerchant,
          ...(storageParams.skip || []),
        ],
        block: true,
      }], 12)),
      ...[
        ...afterSupportedFields,
        ['FieldFreeShipping', {
          name: `shipping.${provider}.free`,
          label: 'Free Shipping',
          skip: [
            activityNotEdit,
            storeTypeNotMerchantNorReseller,
            notSupportedTest,
          ],
          ...freeShippingParams,
          shippingProvider: provider,
          initialValue: {},
        }],
        ...extraFields.map((([field, config = {}]) => [
          field,
          {
            ...config,
            skip: [
              activityNotEdit,
              storeTypeNotMerchantNorReseller,
              ...(config.skip || []),
            ],
          },
        ])),
      ].map((fieldConfig) => Admin.compileFromLibrary([
        fieldConfig[0],
        {
          ...fieldConfig[1],
          hidden: [
            // ['condition.fieldIsNotTrue', `show_${provider}`],
            ...(fieldConfig[1].hidden || []),
            isToggleHidden,
          ],
        },
      ])),
    );
    return agr;
  },
  [],
);

export const fieldPosHeaderImage = ['FieldUploadRefs', {
  name: 'posHeaderImage',
  label: 'Header Image',
  help: 'Recommended: 1600x900px PNG image with transparent background.',
  accept: 'image/jpg,image/jpeg,image/png',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 1600 }],
  ],
  col: 1,
}];

export const fieldPosOutletAppIcon = ['FieldUploadRefs', {
  name: 'posOutletAppIcon',
  label: 'App Icon',
  help: 'Recommended: 512x512px image (used when adding to home screen).',
  accept: 'image/jpg,image/jpeg,image/png',
  transformations: [
    ['GM', { command: 'compress', maxWidth: 512 }],
  ],
  col: 1,
}];

export const fieldPosQrCodeColor = ['FieldColorPicker', {
  name: 'posQrCodeColor',
  label: 'QR Code Color',
  disableAlpha: true,
}];

export const fieldPosBackgroundColor = ['FieldColorPicker', {
  name: 'posBackgroundColor',
  label: 'Background Color',
  disableAlpha: true,
}];

export const fieldPosOutletCheckEvery = ['FieldText', {
  name: 'posOutletCheckEvery',
  label: 'Check Every',
  addonAfter: 's',
  align: 'right',
  initialValue: 5,
  skip: [tests.viewerIsNotThehiveRsAdmin],
  type: 'number',
}];

export const fieldPosOutletClearAfter = ['FieldText', {
  name: 'posOutletClearAfter',
  label: 'Clear After',
  addonAfter: 's',
  align: 'right',
  initialValue: 60,
  type: 'number',
}];

export const actionOpenPosOutlet = ['Action', {
  name: 'open-pos-outlet',
  title: 'Open POS Outlet',
  // eslint-disable-next-line no-unused-vars
  onClick: (props) => {
    window.open('/admin/store/orders/outlet');
  },
  ghost: true,
  skip: [
    tests.viewerIsNotSeller,
    [
      'condition.fieldIsNotTrue',
      'show_fields_shop_pos',
    ],
  ],
  style: { width: '100%' },
}];

export const actionPosClearOutlet = ['ActionWithRequest', {
  name: 'clear-pos-outlet',
  title: 'Clear POS Outlet',
  // eslint-disable-next-line no-unused-vars
  getRequestConfig: props => ({
    url: 'orders/posoutlet',
    method: 'POST',
  }),
  ghost: true,
  skip: [
    tests.viewerIsNotSeller,
    [
      'condition.fieldIsNotTrue',
      'show_fields_shop_pos',
    ],
  ],
  style: { width: '100%' },
}];

export const fieldsBanking = [
  ['name', 'Bank Name'],
  ['branch', 'Bank Branch'],
  ['iban', 'IBAN'],
  ['accountNumber', 'Account Number'],
  ['accountHolderName', 'Account Holder Name', 24],
].map(([name, label, col = { xs: 24, lg: 12 }]) => (['FieldText', {
  name: `banking.${name}`,
  label,
  col,
}]));

export const fieldAiBioShort = ['FieldTextArea', {
  label: 'Short Bio',
  name: 'ai.bioShort',
  placeholder: 'Explain your store motto in a sentence',
  autoSize: { minRows: 1 },
}];

export const fieldReviewSupported = ['FieldSwitch', {
  name: 'reviewSupported',
  label: null,
  inlineLabelBefore: 'Use Reviews?',
  initialValue: true,
}];

export const fieldReviewAvailableFor = ['FieldText', {
  name: 'reviewAvailableFor',
  label: 'Review Available For',
  initialValue: 14,
  type: 'number',
  help: 'Days after the order is marked as delivered',
  rules: [['validation.isNumber']],
  addonAfter: 'days',
  // col: { xs: 24, lg: 12 },
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

export const fieldReviewApproveAbove = ['FieldRadio', {
  name: 'reviewApproveAutomaticallyAbove',
  label: 'Automatically Approve Above',
  initialValue: 4,
  choices: [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ],
  // eslint-disable-next-line max-len
  help: 'Reviews with a rating above this value will be automatically approved. Set to 0 to auto-approve all reviews or 5 to require manual approval for all reviews.',
  block: true,
  col: { xs: 24, lg: 12 },
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

export const fieldReviewCommentAbove = ['FieldRadio', {
  name: 'reviewCommentRequiredUnder',
  label: 'Comment Required For Rating',
  initialValue: 4,
  choices: [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ],
  // eslint-disable-next-line max-len
  help: 'Reviews with a rating of this and lower values will require a comment. Set to 5 to require comments on all reviews or 0 to require no comments.',
  block: true,
  col: { xs: 24, lg: 12 },
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

export const fieldReviewShowRatingOnProductCard = ['FieldRadio', {
  name: 'reviewShowRatingOnProductCard',
  label: 'Show Star Rating On Product Card',
  initialValue: true,
  choices: [{
    label: 'Enabled',
    value: true,
  }, {
    label: 'Disabled',
    value: false,
  }],
  block: true,
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

export const fieldReviewShowRatingOnProductPage = ['FieldRadio', {
  name: 'reviewShowRatingOnProductPage',
  label: 'Show Star Rating On Product Page',
  initialValue: true,
  choices: [{
    label: 'Enabled',
    value: true,
  }, {
    label: 'Disabled',
    value: false,
  }],
  block: true,
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

export const fieldReviewShowCommentOnProductPage = ['FieldRadio', {
  name: 'reviewShowCommentOnProductPage',
  label: 'Show Comments On Product Page',
  initialValue: true,
  choices: [{
    label: 'Enabled',
    value: true,
  }, {
    label: 'Disabled',
    value: false,
  }],
  block: true,
  disabled: [['condition.fieldIsNotTrue', 'reviewSupported']],
}];

const ModalTitleWrapper = styled.div`
  color: ${({ theme }) => theme.less.textColor} !important;
`;

const ModalTitle = styled.div`
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const ModalTitleDescription = styled.div`
  font-weight: 400;
`;

export const activationFormModalConfig = {
  name: 'activate',
  title: 'Request Store Activation',
  ghost: true,
  canToggleModalOpen: () => true,
  modalProps: {
    description: 'adsgfasdfasdfasdsf',
    centered: true,
    closable: true,
    // footer: false,
    width: '100%',
    destroyOnClose: true,
    style: {
      maxWidth: '600px',
      width: 'calc(100% - 30px) !important',
      // padding: '50px !important',
    },
    title: (
      <ModalTitleWrapper>
        <ModalTitle>
          Store Activation Form
        </ModalTitle>
        <ModalTitleDescription>
          Make sure to fill out your banking information
          and upload the required documents.
        </ModalTitleDescription>
      </ModalTitleWrapper>
    ),
  },
  fields: [
    ['FieldTitle', { title: 'Documents' }],
    fieldDocumentPersonal,
    fieldDocumentPersonalExpirationDate,
    fieldDocumentBusiness,
    fieldDocumentBusinessExpirationDate,
    ['FieldTitle', { title: 'Banking Info' }],
    ...fieldsBanking.map(field => Admin.compileFromLibrary([field[0], {
      ...field[1],
    }])),
  ],
};

export const FIELDS_SOCIAL_RAW = [
  fieldFacebookHref,
  fieldInstagramHref,
  fieldTwitterHref,
  fieldWhatsappHref,
  fieldTiktokHref,
  fieldSnapchatHref,
  fieldYoutubeHref,
];

export const FIELDS_SOCIAL = [

  // Social
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_social_social',
    initialValue: false,
    title: 'Social Media',
    // size: 'medium',
    subtitle: 'Setup your social media links',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...FIELDS_SOCIAL_RAW.map(field => (
    Admin.compileFromLibrary([field[0], {
      ...field[1],
      hidden: [[
        'condition.fieldIsNotTrue',
        'show_fields_social_social',
      ]],
    }])
  )),
];

export const FIELDS_FONTS = [
  // fieldI18nLanguage,
  fieldFontPreview,
  ['FieldTitle', { title: 'Title Font' }],
  ...fieldsStyleFontTitle.map(field => getFilterWithCol(field, 12)),
  ['FieldTitle', { title: 'Body Font' }],
  ...fieldsStyleFontBody.map(field => getFilterWithCol(field, 12)),
  ['FieldTitle', { title: 'Label Font' }],
  ...fieldsStyleFontLabel.map(field => getFilterWithCol(field, 12)),
];

export const FIELDS_WEBSITE = [
  fieldI18nLanguage,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Website',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldName,
  fieldStoreId,
  fieldSlug,
  fieldInternal,
  fieldType,
  fieldDomains,
  fieldLanguage,
  fieldLanguages,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_brand',
    initialValue: false,
    title: 'Brand',
    // size: 'medium',
    subtitle: 'Setup your brand',
    skip: [
      activityNotEdit,
    ],
  }])),
  fieldLogo,
  fieldLogoDark,
  fieldFavicon,
  Admin.compileFromLibrary(getFilterWithCol(fieldBrandColor, 24)),
  Admin.compileFromLibrary(getFilterWithCol(fieldAccentColorPrimary, 12)),
  Admin.compileFromLibrary(getFilterWithCol(fieldAccentColorSecondary, 12)),

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_social_meta',
    initialValue: true,
    title: 'Meta',
    // size: 'medium',
    subtitle: 'Setup your website meta content',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...fieldsMeta,
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_website_integrations',
    initialValue: false,
    title: 'Integrations',
    // size: 'medium',
    subtitle: 'Setup your website scripts',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...fieldsIntegrations,
  ...FIELDS_SOCIAL,
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_website_consent',
    initialValue: false,
    title: 'Consent Screen',
    // size: 'medium',
    subtitle: 'Toggle using and setup your consent screen',
    skip: [
      activityNotEdit,
    ],
  }])),
  fieldConsentActive,
  fieldConsentTitle,
  fieldConsentBody,
  fieldConsentLabelConfirm,
  fieldConsentLabelDeny,
  // fieldConsentRedirectUrl,
];

export const FIELDS_ACCOUNT = [
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Account',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldInternal,
  fieldType,
  fieldEmail,
  fieldPhoneNumberString,
  fieldAccountManager,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Order Limits',
  }]),
  fieldSingleItemPerOrder,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Plan',
    // eslint-disable-next-line arrow-body-style
    getSubtitle: (subtitle, props) => {
      return `${
        props.data.subscriptionInUse?.label
      } - Paid ${
        Types.STORE_SUBSCRIPTION_MODE_MAP[props.data.subscriptionMode]?.label
      }`;
    },
  }]),
  Admin.compileFromLibrary(['FieldReact', {
    label: null,
    renderContent: (props) => {
      // const tier = props.form.getFieldValue('tier');
      let { data: { subscriptionStatus: status } } = props;
      if (status) {
        status = {
          ...status,
          // eslint-disable-next-line max-len
          message: status.message.replace(/\[expires:([^\]]+)\]/, (all, time) => (
              time === 'from'
            ? moment(status.expires).from(new Date())
            : time === 'date'
            ? moment(status.expires).format('ll')
            : ''
          )),
        };
      }
      return (
        status
        ? (
            <Alert
              type={status.kind}
              message={status.message}
              showIcon
            />
          )
        : null
      );
    },
    virtual: [() => true],
  }]),
  Admin.compileFromLibrary(['ActionWithFormModal', {
    id: 'subscription-updates',
    name: 'subscription-updates',
    title: 'Update Subscription',
    style: { width: '100%' },
    ghost: true,
    fields: [
      fieldSubscriptionMode,
      Admin.compileFromLibrary([fieldSubscription[0], {
        ...fieldSubscription[1],
        label: 'Set Subscription',
      }]),
      fieldSubscriptionCustomPercentage,
      fieldSubscriptionCustomDuration,
      fieldSubscriptionCustomPrice,
      Admin.compileFromLibrary(['FieldRadio', {
        name: 'charge',
        // label: null,
        label: 'Set Amount to Charge',
        choices: [
          { label: 'Skip', value: false },
          { label: 'Subscription Price', value: true },
          { label: 'Custom Amount', value: 'CUSTOM' },
        ],
        initialValue: false,
        block: true,
        renderChoice: (choice, field, props) => {
          let render = (
            <props.choiceClass
              key={props.getChoiceValue(choice, field, props)}
              value={props.getChoiceValue(choice, field, props)}
            >
              {props.getChoiceLabel(choice, field, props)}
            </props.choiceClass>
          );
          // console.log(choice);
          if (choice.value === false) {
            render = React.cloneElement(render, {
              style: { maxWidth: '100px' },
            });
          }
          return render;
        },
        skip: [subscriptionModeIsOffline],
      }]),
      Admin.compileFromLibrary(['FieldText', {
        label: null,
        name: 'chargeCustom',
        initialValue: 0,
        // prefix: 'Custom Amount:',
        type: 'number',
        align: 'right',
        addonAfter: renderCurrency(),
        skip: [
          subscriptionModeIsOffline,
          [
            'condition.testFieldValue',
            'charge',
            '!==',
            'CUSTOM',
          ],
        ],
      }]),
      Admin.compileFromLibrary(['FieldRadio', {
        name: 'expires',
        // label: null,
        label: 'Set Subscription Valid Until',
        choices: [
          { label: 'Skip', value: false },
          { label: 'Subscription Period', value: true },
          { label: 'Custom Date', value: 'CUSTOM' },
        ],
        renderChoice: (choice, field, props) => {
          let render = (
            <props.choiceClass
              key={props.getChoiceValue(choice, field, props)}
              value={props.getChoiceValue(choice, field, props)}
            >
              {props.getChoiceLabel(choice, field, props)}
            </props.choiceClass>
          );
          // console.log(choice);
          if (choice.value === false) {
            render = React.cloneElement(render, {
              style: { maxWidth: '100px' },
            });
          }
          return render;
        },
        skip: [subscriptionModeIsOffline],
        initialValue: false,
        block: true,
      }]),
      Admin.compileFromLibrary(['FieldDatePicker', {
        label: null,
        name: 'expiresCustom',
        format: 'll',
        getInitialValue: () => new Date(),
        placeholder: 'Date subscription expires',
        skip: [
          subscriptionModeIsOffline,
          [
            'condition.testFieldValue',
            'expires',
            '!==',
            'CUSTOM',
          ],
        ],
        prepareValueForInput: value => moment(value),
      }]),
      [fieldSubscriptionStartsAt[0], {
        ...fieldSubscriptionStartsAt[1],
        label: 'Set Subscription Starts Date',
      }],
    ],
    actions: [
      ['ActionWithFormBasedRequest', {
        name: 'subscription-update-submit',
        title: 'Submit Updates',
        // eslint-disable-next-line arrow-body-style
        getRequestConfig: (props, data) => {
          return {
            url: `/stores/${props.data._id}/subscription`,
            method: 'POST',
            data: {
              ...data,
            },
          };
        },
        handleSuccess: (data, props) => {
          props.cancel();
          props.reload();
        },
      }],
    ],
    virtual: [() => true],
    skip: [
      viewerIsNotAdmin,
    ],
  }]),
  ['ActionWithFormModal', {
    name: 'update-plan',
    title: 'Update Plan',
    ghost: true,
    style: { width: '100%' },
    skip: [
      () => true,
      viewerIsAdmin,
      props => (
        !props.data
        || props.data.active
        || props.data.subscriptionMode !== StoreSubscriptionMode.ONLINE
        || props.data.subscriptionInUse?.id === 'CUSTOM'
      ),
    ],
    fields: [
      ['FieldHidden', {
        name: 'subscription',
      }],
      Admin.compileFromLibrary(['FieldStoreSubscription', {
        name: 'subscriptionToUse',
        label: null,
        getInitialValue: (fieldConfig, formProps) => {
          const currentSubscription = formProps.form.getFieldValue(
            'subscription'
          );
          if (currentSubscription) {
            return currentSubscription;
          }
          return null;
        },
      }]),
    ],
    actions: [
      ['ActionWithFormBasedRequest', {
        name: 'subscription-update-submit',
        title: 'Submit',
        style: { width: '100%' },
        // eslint-disable-next-line arrow-body-style
        getRequestConfig: (props) => {
          return {
            url: `/stores/${props.data._id}/update-subscription-customer`,
            method: 'POST',
            data: props.form.getFieldsValue(),
          };
        },
        handleSuccess: (data, props) => {
          props.reload();
        },
      }],
    ],
  }],
  fieldKeyAccountActive,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Packman services',
    // eslint-disable-next-line arrow-body-style
    getSubtitle: (subtitle, props) => {
      return 'Subscription to packman services';
    },
  }]),
  fieldAccountManagerActive,
  fieldAccountManagerSubscriptionStartsAt,
  fieldAccountManagerSubscriptionEndsAt,
  fieldWarehouseServiceActive,
  fieldWarehouseServiceSubscriptionStartsAt,
  fieldWarehouseServiceSubscriptionEndsAt,
  Admin.compileFromLibrary(fieldCheckoutCardsTitle),
  Admin.compileFromLibrary(fieldCheckoutCards),
  Admin.compileFromLibrary(['ActionWithFormModal', {
    ...activationFormModalConfig,
    title: 'Start Selling!',
    disabled: [(props) => !props.data?.card?.id],
    skip: [
      viewerIsAdmin,
      props => (
        !props.data
        || props.data.active
        || props.data.subscriptionMode !== StoreSubscriptionMode.ONLINE
      ),
    ],
    ghost: false,
    style: { marginTop: '20px', width: '100%' },
    actions: [
      ['ActionWithRequest', {
        name: 'activate-online',
        title: 'Start Selling!',
        // ghost: true,
        block: true,
        style: { marginTop: '20px', width: '100%' },
        getRequestConfig: props => ({
          url: `stores/${props.data._id}/activate-online`,
          data: {},
          method: 'POST',
        }),
        // eslint-disable-next-line max-len
        popconfirm: {
          title: (
            <p>
              You will be charged for the subcription plan amount.
            </p>
          ),
        },
        messageSuccess: [
          'That\'s it! Your store is now active!',
        ].join(' '),
        handleSuccess: (data, props) => props.reload(),
      }],
    ],
  }]),
  // Expireables
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Expiry Notifications',
    skip: [viewerIsNotAdmin],
  }]),
  Admin.compileFromLibrary(['FieldSortableList', {
    name: 'expireables',
    skip: [viewerIsNotAdmin],
    label: null,
    condensed: true,
    fields: [
      getFilterWithCol(['FieldSelect', {
        name: 'type',
        label: null,
        prefix: 'Type:',
        choices: Types.STORE_EXPIREABLE_ITEMS.map(item => ({
          label: item.label,
          value: item.id,
        })),
      }], 24),
      ...[
        // ['startsAt', 'Starts At', 'startOf'],
        ['expiresAt', 'Expires At', 'endOf'],
      ].map(([name, label]) => getFilterWithCol(['FieldDatePicker', {
        name,
        label: null,
        placeholder: label,
        format: [`[${label}]: DD.MM.YYYY.`, 'DD.MM.YYYY.'],
        getInitialValue: (fieldConfig, formProps) => {
          const originalInitialValue = Field.config.getInitialValue(
            fieldConfig,
            formProps,
          );
          if (isUndefined(originalInitialValue)) {
            return undefined;
          }
          return moment(originalInitialValue);
        },
        prepareValueForInput: value => (
          (value ? moment(value) : undefined)
          // .startOf('day')
        ),
      }], 24)),
      getFilterWithCol(['FieldTextArea', {
        name: 'note',
        prefix: 'Note',
        label: null,
        placeholder: 'Note (optional)',
        autoSize: { minRows: 1 },
      }], 24),
    ],
  // ...Types.STORE_EXPIREABLE_ITEMS.reduce(
  //   (agr, expireable) => {
  //     agr.push(
  //       Admin.compileFromLibrary(['FieldTitle', {
  //         title: expireable.label,
  //         size: 'medium',
  //       }]),
  //       Admin.compileFromLibrary(['FieldSortableList', {
  //         name: 'expireables',
  //       }]),
  //     );
  //     return agr;
  //   },
  //   [],
  // ),
  }]),
];

export const FIELDS_STYLE = [
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Style',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  // Admin.compileFromLibrary(['FieldTitle', { title: 'Theme' }]),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleTheme, 24)),
  // Admin.compileFromLibrary(getFilterWithCol(fieldStyleThemeSwitch, 12)),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleRoundness, 24)),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleIconsStyle, 24)),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleButtonStyle, 12)),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleButtonSize, 12)),
  Admin.compileFromLibrary(getFilterWithCol(fieldStyleTransitionStyle, 24)),

  //
  // Navigation
  //
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_navigation',
    initialValue: false,
    title: 'Navigation',
    subtitle: 'Navigation style',
    skip: [
      activityNotEdit,
    ],
  }])),
  fieldNavigationStyle,
  // fieldNavigationAlignment,
  fieldNavigationPosition,
  fieldNavigationActiveItemStyle,
  // fieldNavigationActiveItemPosition,
  fieldNavigationMobileNavigationShow,
  fieldNavigationMobileNavigationStyle,

  //
  // Shop
  //
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_shop',
    initialValue: false,
    title: 'Shop',
    subtitle: 'Shop style',
    skip: [
      activityNotEdit,
    ],
  }])),

  fieldShopGrid,
  fieldShopCartAlignment,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_shop_card',
    initialValue: false,
    title: 'Card',
    subtitle: 'Card style',
    size: 'small',
    skip: [
      activityNotEdit,
    ],
    hidden: [
      ['condition.fieldIsNotTrue', 'show_fields_style_shop'],
    ],
  }])),
  ...[
    getFilterWithCol(fieldImageSizing, 24),
    getFilterWithCol(fieldStyleImageAspectRatio, 12),
    getFilterWithCol(fieldStyleImageParallax, 12),
  ].map(field => Admin.compileFromLibrary([
    field[0],
    {
      ...field[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_style_shop_card'],
        ['condition.fieldIsNotTrue', 'show_fields_style_shop'],
      ],
    },
  ])),
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_gallery',
    initialValue: false,
    title: 'Gallery',
    subtitle: 'Gallery style',
    size: 'small',
    skip: [
      activityNotEdit,
    ],
    hidden: [
      ['condition.fieldIsNotTrue', 'show_fields_style_shop'],
    ],
  }])),
  ...[
    getFilterWithCol(fieldGalleryThumbnails, 8),
    getFilterWithCol(fieldGalleryDotNavigation, 8),
    getFilterWithCol(fieldGalleryArrowsNavigation, 8),
    getFilterWithCol(fieldGalleryOverflow, 24),
    getFilterWithCol(fieldGalleryZoom, 24),
  ].map(field => Admin.compileFromLibrary([
    field[0],
    {
      ...field[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_style_gallery'],
        ['condition.fieldIsNotTrue', 'show_fields_style_shop'],
      ],
    },
  ])),
  // Admin.compileFromLibrary(getFilterWithCol(fieldGalleryFullscreen, 12)),

  //
  // Fonts
  //
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_fonts',
    initialValue: false,
    title: 'Fonts',
    subtitle: 'Setup your website fonts',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...FIELDS_FONTS.map(field => Admin.compileFromLibrary([
    field[0],
    {
      ...field[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_style_fonts'],
      ],
    },
  ])),
  //
  // Colors
  //

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_colors',
    initialValue: false,
    title: 'Colors',
    subtitle: 'Setup your website colors',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...[
    ...fieldsStyleColorsLight,
    ...fieldsStyleColorsDark,
  ].map(field => Admin.compileFromLibrary([
    field[0],
    {
      ...field[1],
      hidden: [
        ...field[1].hidden || [],
        ['condition.fieldIsNotTrue', 'show_fields_style_colors'],
      ],
    },
  ])),

  //
  // Advanced
  //

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_style_advanced',
    initialValue: false,
    title: 'Advanced',
    subtitle: 'Advanced style settings',
    skip: [
      activityNotEdit,
    ],
  }])),
  Admin.compileFromLibrary([fieldStyleCss[0], {
    ...fieldStyleCss[1],
    hidden: [
      ['condition.fieldIsNotTrue', 'show_fields_style_advanced'],
    ],
    col: 24,
  }]),
];

export const FIELDS_NAVIGATION = [
  fieldI18nLanguage,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Navigation',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldNavigationCurrenciesShow,
  fieldNavigationSocialHide,
  fieldAnnouncement,
  fieldNavigationItems,
  fieldNavigationActions,
];

export const FIELDS_AI = [
  fieldI18nLanguage,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'AI Settings',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldAiBioShort,
];

export const FIELDS_SHOP = [
  // fieldI18nLanguage,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Shop',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldServiceFee,
  fieldServiceFeeFixed,
  fieldServiceFeePercentage,
  fieldShowItemsLeftInStockThreshold,
  fieldShowPricesWithVat,
  fieldStoreCategories,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_payment',
    initialValue: false,
    title: 'Payment',
    subtitle: 'Setup your shop payment methods',
    skip: [
      activityNotEdit,
      viewerIsNotAdmin,
    ],
  }])),
  fieldAppleDeveloperMerchantIdDomainAssociationVerified,
  fieldAppleDeveloperMerchantIdDomainAssociationFile,
  fieldPaymentCardProvider,
  fieldPaymentCheckoutInternationalSupport,
  fieldPaymentPaymobInternationalSupport,
  // fieldPaymentTamaraSupported,
  fieldPaymentTabbySupported,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_sections',
    initialValue: false,
    title: 'Sections',
    subtitle: 'Choose which sections you want to show in your shop',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...fieldsShopHide,
  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_banners',
    initialValue: false,
    title: 'Banners',
    subtitle: 'Setup your shop banners',
    skip: [
      activityNotEdit,
    ],
  }])),
  Admin.compileFromLibrary(getFilterWithCol([
    fieldShopBannersAutoplay[0],
    {
      ...fieldShopBannersAutoplay[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_shop_banners'],
      ],
    },
  ], 12)),
  Admin.compileFromLibrary(getFilterWithCol([
    fieldShopBannersOverflow[0],
    {
      ...fieldShopBannersOverflow[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_shop_banners'],
      ],
    },
  ], 12)),
  fieldShopBanners,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_sidebar',
    initialValue: false,
    title: 'Sidebar',
    subtitle: 'Setup your shop sidebar',
    skip: [
      activityNotEdit,
    ],
  }])),
  Admin.compileFromLibrary(['FieldRadio', {
    name: 'shopDefaultSort',
    label: 'Default Sort',
    hidden: [
      ['condition.fieldIsNotTrue', 'show_fields_shop_sidebar'],
    ],
    initialValue: Types.STORE_SHOP_DEFAULT_SORT[0],
    block: true,
    choices: Types.STORE_SHOP_DEFAULT_SORT_LIST.map(({ id, label }) => ({
      value: id,
      label,
    })),
  }]),
  fieldCategories,
  fieldCollections,

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_reviews',
    initialValue: false,
    title: 'Reviews',
    // size: 'medium',
    subtitle: 'Setup your product reviews',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...[
    fieldReviewSupported,
    fieldReviewApproveAbove,
    fieldReviewCommentAbove,
    fieldReviewAvailableFor,
    // fieldReviewShowRatingOnProductCard,
    // fieldReviewShowRatingOnProductPage,
    // fieldReviewShowCommentOnProductPage,
  ].map(field => Admin.compileFromLibrary([field[0], {
    ...field[1],
    hidden: [[
      'condition.fieldIsNotTrue',
      'show_fields_shop_reviews',
    ]],
  }])),

  Admin.compileFromLibrary(asLocalStorageField(['FieldTitleToggle', {
    name: 'show_fields_shop_pos',
    initialValue: false,
    title: 'POS',
    subtitle: 'Setup your shop POS',
    skip: [
      activityNotEdit,
    ],
  }])),
  ...[
    fieldPosHeaderImage,
    fieldPosOutletAppIcon,
    ['FieldReact', {
      label: null,
      renderContent: () => null,
      formItemConfig: {
        style: { marginBottom: '0px', height: '0px' },
      },
    }],
    getFilterWithCol(fieldPosQrCodeColor, 12),
    getFilterWithCol(fieldPosBackgroundColor, 12),
    fieldPosOutletCheckEvery,
    fieldPosOutletClearAfter,
    getFilterWithCol(actionOpenPosOutlet, 12),
    getFilterWithCol(actionPosClearOutlet, 12),
  ].map(field => Admin.compileFromLibrary([
    field[0],
    {
      ...field[1],
      hidden: [
        ['condition.fieldIsNotTrue', 'show_fields_shop_pos'],
      ],
    },
  ])),
];

export const FIELDS_SHIPPING = [
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Shipping',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldShippingAutoReadyForPickupFromLocalStorage,
  fieldShippingScheduledDeliverySupport,
  fieldShippingCountriesAvailability,
  fieldShippingCountriesList,
  fieldPhoneNumberPickupString,
  fieldAddress,
  fieldHours,
  fieldI18nLanguage,
  ...fieldsShipping,
];

export const FIELDS_LEGAL = [
  // fieldI18nLanguage,
  Admin.compileFromLibrary(['FieldTitle', {
    title: 'Legal',
    style: { marginTop: -20, fontSize: 32 },
  }]),
  fieldTrnActive,
  fieldTrnNumber,
  fieldStrictTermsAndConditions,
  fieldPoliciesTnc,
  fieldDocuments,
  Admin.compileFromLibrary(fieldDocumentPersonal),
  Admin.compileFromLibrary(fieldDocumentPersonalExpirationDate),
  Admin.compileFromLibrary(fieldDocumentBusiness),
  Admin.compileFromLibrary(fieldDocumentBusinessExpirationDate),
  Admin.compileFromLibrary(['FieldTitle', { title: 'Popups' }]),
  fieldCookiesConsentActive,
  fieldConsentActive,
  fieldConsentTitle,
  fieldConsentBody,
  fieldConsentLabelConfirm,
  fieldConsentLabelDeny,
  Admin.compileFromLibrary(['FieldTitle', { title: 'Banking' }]),
  ...fieldsBanking.map(field => Admin.compileFromLibrary(field)),
];

export const FIELDS_CREATE = [
  // fieldI18nLanguage,
  fieldName,
  fieldSlug,
  fieldInternal,
  fieldType,
  fieldEmail,
  fieldPhoneNumberString,
  fieldPhoneNumberPickupString,
  fieldAddress,
  Admin.compileFromLibrary([fieldSubscription[0], {
    ...fieldSubscription[1],
  }]),
  fieldSubscriptionMode,
  fieldSubscriptionCustomPrice,
  fieldSubscriptionCustomDuration,
  fieldSubscriptionCustomPercentage,
  fieldSubscriptionStartsAt,
];
